var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { INDRABFMDataStorageService } from "@ibe.services/bfm-data-storage.indra.service";
import { BehaviorSubject, Subject } from "rxjs";
import * as _ from 'lodash';
import { BRAND_DESCRIPTION_DISCOUNT, BRAND_DESCRIPTION_CLASSIC, BRAND_DESCRIPTION_PLUS, BRAND_DESCRIPTION_EXECUTIVE, BRAND_DESCRIPTION_BASIC, BRAND_DESCRIPTION_TOP_EXECUTIVE, ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE, ANCILLARY_PRODUCT_GROUP_CODE_MEAL, ANCILLARY_GROUP_LOUNGE_LIST, ANCILLARY_GROUP_MEAL_LIST, ANCILLARY_PRODUCT_GROUP_CODE_WHEELCHAIR, ANCILLARY_GROUP_WHEELCHAIR_LIST, ANCILLARY_PRODUCT_GROUP_CODE_SERVICE_ANIMAL, ANCILLARY_GROUP_SERVICE_ANIMAL_LIST, ANCILLARY_PRODUCT_GROUP_CODE_BLIND_ASSISTANCE, ANCILLARY_GROUP_BLIND_ASSISTANCE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_DEAF_ASSISTANCE, ANCILLARY_GROUP_DEAF_ASSISTANCE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_LUGGAGE_BABY_BASKET, ANCILLARY_GROUP_LUGGAGE_BABY_BASKET_LIST, ANCILLARY_PRODUCT_GROUP_CODE_ANIMAL_IN_HOLD, ANCILLARY_GROUP_ANIMAL_IN_HOLD_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN, ANCILLARY_GROUP_PET_IN_CABIN_LIST, ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE, ANCILLARY_GROUP_HOLD_BAGGAGE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_BULKY_BAGGAGE, ANCILLARY_GROUP_BULKY_BAGGAGE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK, ANCILLARY_GROUP_FAST_TRACK_LIST, ANCILLARY_PRODUCT_GROUP_CODE_MUSIC_INSTRUMENT, ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST, ANCILLARY_PRODUCT_GROUP_CODE_SPORTS_EQUIPMENT, ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST, ANCILLARY_PRODUCT_GROUP_CODE_EXTRA_SEAT, ANCILLARY_GROUP_EXTRA_SEAT_LIST, ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION, ANCILLARY_GROUP_SEAT_RESERVATION_LIST, ANCILLARY_PRODUCT_GROUP_CODE_WEAPON, ANCILLARY_GROUP_WEAPON_LIST, ANCILLARY_PRODUCT_GROUP_CODE_MEDICAL_ASSISTANCE, ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_UNACCOMPANIED_MINOR, ANCILLARY_GROUP_UNACCOMPANIED_MINOR_LIST, ANCILLARY_PRODUCT_GROUP_CODE_KIOSK, ANCILLARY_GROUP_KIOSK_LIST, ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE, ANCILLARY_GROUP_HAND_BAGGAGE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_BOARDING, ANCILLARY_GROUP_PREMIUM_BOARDING_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN, ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_CUSTOMER_CENTER, ANCILLARY_GROUP_PREMIUM_CUSTOMER_CENTER_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_BAGGAGE, ANCILLARY_GROUP_PRIORITY_BAGGAGE_LIST, ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD, ANCILLARY_GROUP_PREF_BOARDING_LIST, BRAND_CODE_DISCOUNT, BRAND_CODE_CLASSIC, BRAND_CODE_PLUS, BRAND_CODE_EXECUTIVE, BRAND_CODE_BASIC, BRAND_CODE_TOP_EXECUTIVE, PAX_TYPE_INFANT_CODE, EXTRAS_ANCILLARY_MEAL, UNCONFIRMED_CODES, AIR_LINE_CODE_TAP, TP_EXPRESS_LOGO, PAX_TYPE_CHILD_CODE, EXTRAS_ANCILLARY_BAG, EXTRAS_ANCILLARY_SEAT, EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_ANIMAL, EXTRAS_ANCILLARY_FAST_TRACK, EXTRAS_ANCILLARY_LOUNGE, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_SEAT_SSR, TAP_MILES_AND_GO_MILES, TAP_MILES_AND_GO_MILS, TAP_MILES_AND_GO_SILVER, TAP_MILES_AND_GO_GOLD, TAP_MILES_AND_GO_NAVIGATOR, TAP_MILES_AND_GO_MILES_LABEL, TAP_MILES_AND_GO_SILVER_LABEL, TAP_MILES_AND_GO_GOLD_LABEL, TAP_MILES_AND_GO_NAVIGATOR_LABEL, SEATMAP_AIRBUS_A319_100_CODE, SEATMAP_AIRBUS_A320_200_CODE, SEATMAP_AIRBUS_A321_200_CODE, SEATMAP_AIRBUS_A330_200_RETROFIT_CODE, SEATMAP_AIRBUS_A340_300_CODE, SEATMAP_AIRBUS_ATR_72_600_CODE, SEATMAP_EMBRAER_190_CODE, SEATMAP_EMBRAER_195_CODE, SEATMAP_EQUIPMENT_FOLDER_A319_A320_A321, SEATMAP_EQUIPMENT_FOLDER_A332, SEATMAP_EQUIPMENT_FOLDER_A340, SEATMAP_EQUIPMENT_FOLDER_ATR, SEATMAP_EQUIPMENT_FOLDER_EMBRAER, SEATMAP_SEAT_TYPE_STANDARD, SEATMAP_SEAT_TYPE_PREFERED, SEATMAP_SEAT_TYPE_BUSINESS, SEATMAP_SEAT_TYPE_FOLDER_STANDARD, SEATMAP_SEAT_TYPE_FOLDER_PREFERED, SEATMAP_SEAT_TYPE_FOLDER_EXECUTIVE, SEATMAP_SEAT_TYPE_FOLDER_BUSINESS, SEATMAP_SEAT_TYPE_FOLDER_GENERAL, SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT, SEATMAP_SEAT_IMAGE_PATH_INTERIORES_195, EQUIPMENT_CODE_TRAIN, EQUIPMENT_CODE_BUS, SEATMAP_AIRBUS_A320_NEO_CODE, SEATMAP_AIRBUS_A321_NEO_CODE, SEATMAP_AIRBUS_A330_NEO_CODE, SEATMAP_EQUIPMENT_FOLDER_A321_LR, SEATMAP_EQUIPMENT_FOLDER_A330_NEO, TAP_GDS_OFFICE_PATTERN, EXPEDIA_GDS_OFFICE_PATTERN, EDREAMS_GDS_OFFICE_PATTERN, OPODO_GDS_OFFICE_PATTERN, CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER, AIRPLANE_EQUIPMENT_CODE_32Q, AIRPLANE_EQUIPMENT_CODE_332, COUNTRY_CODE_USA, AIRPLANE_EQUIPMENT_CODE_32N, AIRPLANE_EQUIPMENT_CODE_339, TRIP_TYPE_MULTICITY_CODE } from "@ibe.config";
import { BookingStep } from "@ibe/models/ui";
import { INDRABookingStep } from "@ibe.components/booking/steps/booking-steps/bookingStep.indra";
import { INDRADateService } from "@ibe.services/date.indra.service";
import { PURCHASED_ANCILLARY_BAG, PURCHASED_ANCILLARY_EXTRA_FAST_TRACK, PURCHASED_ANCILLARY_EQUIPMENT, PURCHASED_ANCILLARY_EXTRA_MEAL, PURCHASED_ANCILLARY_EXTRA_ANIMAL, PURCHASED_ANCILLARY_EXTRA_LOUNGE, PURCHASED_ANCILLARY_EXTRA_MUSICAL } from "@ibe.components/shared/flight-brand-features-list/features.indra";
import { INDRATotalSummaryService } from "@ibe.services/total-summary.service";
import { BUSINESS_A321LR, BUSINESS_A330, BUSINESS_A320NEO, BUSINESS_A330NEO, BUSINESS_DEFAULT } from "@ibe.components/shared/sidebar-views/ancillaries/seatmap/seatmap.characteristic";
import { INDRARetrievePnrService } from '@ibe.services/retrieve-pnr.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { FlightEquipmentEnum } from '@ibe.components/shared/_models/enums/flight-equipment.enum';
import { takeWhile } from "rxjs/operators";
import { Store } from "@ngrx/store";
import * as fromStore from '../store';
import * as BookingStepActions from '@ibe/store/actions/booking-steps.actions';
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "./bfm-data-storage.indra.service";
import * as i2 from "./date.indra.service";
import * as i3 from "./total-summary.service";
import * as i4 from "./retrieve-pnr.indra.service";
import * as i5 from "./ibeadmin.indra.service";
import * as i6 from "@ngrx/store";
import * as i7 from "@angular/router";
var INDRABookingService = /** @class */ (function () {
    function INDRABookingService(dataStorage, dateService, totalSummaryService, bookingDocumentService, ibeAdminService, store, router) {
        var _this = this;
        this.dataStorage = dataStorage;
        this.dateService = dateService;
        this.totalSummaryService = totalSummaryService;
        this.bookingDocumentService = bookingDocumentService;
        this.ibeAdminService = ibeAdminService;
        this.store = store;
        this.router = router;
        this.steps = new BehaviorSubject(null);
        this.current_step = new BehaviorSubject(null);
        this.subjectLinkRoute = new Subject;
        this.linkRoute = this.subjectLinkRoute.asObservable();
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.isAlive = true;
        this.pendingFlight = new Subject();
        this.multiFlights = new Subject();
        this.paymentStatus = new Subject();
        this.bookingTrip = dataStorage.observableCurrentBooking;
        this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (trip) {
            _this.bookedTrip = trip;
        });
    }
    /**
     * Returns corresponding flight of an ID if it exists
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_getBookedFlight = function (id) {
        var returnValue;
        var index = this.dataStorage.activeBooking.data.fare.listOutbound.findIndex(function (outbound) { return outbound.assignedFlightId.toString() === id; });
        if (index === -1) {
            // if id is not present on outbound flight, returns inbound
            if (this.dataStorage.activeBooking.data.fare.listInbound) {
                var inboundIndex = this.dataStorage.activeBooking.data.fare.listInbound.findIndex(function (inbound) { return inbound.assignedFlightId.toString() === id; });
                returnValue = this.dataStorage.activeBooking.data.fare.listInbound[inboundIndex];
            }
        }
        else {
            // returns outbound
            returnValue = this.dataStorage.activeBooking.data.fare.listOutbound[index];
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getBookedFlightBySegment = function (id) {
        var returnValue;
        var outboundVal = this.dataStorage.activeBooking.data.fare.listOutbound.find(function (outbound) { return outbound.listSegment.find(function (segment) { return segment.idInfoSegment.toString() == id; }) != undefined; });
        if (outboundVal == undefined) {
            // if id is not present on outbound flight, returns inbound
            if (this.dataStorage.activeBooking.data.fare.listInbound) {
                var inboundVal = this.dataStorage.activeBooking.data.fare.listInbound.find(function (inbound) { return inbound.listSegment.find(function (segment) { return segment.idInfoSegment.toString() == id; }) != undefined; });
                returnValue = inboundVal;
            }
        }
        else {
            // returns outbound
            returnValue = outboundVal;
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getFlightIdBySegment = function (id) {
        var returnValue;
        var outboundVal = this.dataStorage.activeBooking.data.fare.listOutbound.find(function (outbound) { return outbound.listSegment.find(function (segment) { return segment.idInfoSegment.toString() == id; }) != undefined; });
        if (outboundVal == undefined) {
            // if id is not present on outbound flight, returns inbound
            if (this.dataStorage.activeBooking.data.fare.listInbound) {
                var inboundVal = this.dataStorage.activeBooking.data.fare.listInbound.find(function (inbound) { return inbound.listSegment.find(function (segment) { return segment.idInfoSegment.toString() == id; }) != undefined; });
                returnValue = inboundVal;
            }
        }
        else {
            // returns outbound
            returnValue = outboundVal;
        }
        return returnValue.idFlight;
    };
    /**
     * Returns corresponding Location if it exists
     * @param {string} code of location
     */
    INDRABookingService.prototype.INDRA_getLocation = function (code) {
        return this.dataStorage.activeBooking.translate.locations[code];
    };
    INDRABookingService.prototype.INDRA_getTextTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    /**
     * Returns corresponding Airplane if it exists
     * @param {string} code of airplane
     */
    INDRABookingService.prototype.INDRA_getAirplaneInfo = function (code) {
        var returnObject = {
            code: '',
            name: ''
        };
        if (this.dataStorage.activeBooking.translate.airlines[code]) {
            returnObject = this.dataStorage.activeBooking.translate.airlines[code];
        }
        return returnObject;
    };
    /**
     * Returns all ancillaries associated to the group.
     * @param {string} code of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getSSRAvailableForGroup = function (code) {
        switch (code) {
            case ANCILLARY_PRODUCT_GROUP_CODE_LOUNGE:
                return ANCILLARY_GROUP_LOUNGE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_MEAL:
                return ANCILLARY_GROUP_MEAL_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_WHEELCHAIR:
                return ANCILLARY_GROUP_WHEELCHAIR_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_SERVICE_ANIMAL:
                return ANCILLARY_GROUP_SERVICE_ANIMAL_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_BLIND_ASSISTANCE:
                return ANCILLARY_GROUP_BLIND_ASSISTANCE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_DEAF_ASSISTANCE:
                return ANCILLARY_GROUP_DEAF_ASSISTANCE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_LUGGAGE_BABY_BASKET:
                return ANCILLARY_GROUP_LUGGAGE_BABY_BASKET_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_ANIMAL_IN_HOLD:
                return ANCILLARY_GROUP_ANIMAL_IN_HOLD_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PET_IN_CABIN:
                return ANCILLARY_GROUP_PET_IN_CABIN_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE:
                return ANCILLARY_GROUP_HOLD_BAGGAGE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_BAGGAGE:
                return ANCILLARY_GROUP_PRIORITY_BAGGAGE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_BULKY_BAGGAGE:
                return ANCILLARY_GROUP_BULKY_BAGGAGE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_FAST_TRACK:
                return ANCILLARY_GROUP_FAST_TRACK_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_MUSIC_INSTRUMENT:
                return ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_SPORTS_EQUIPMENT:
                return ANCILLARY_GROUP_SPORTS_EQUIPMENT_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_EXTRA_SEAT:
                return ANCILLARY_GROUP_EXTRA_SEAT_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_SEAT_RESERVATION:
                return ANCILLARY_GROUP_SEAT_RESERVATION_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_WEAPON:
                return ANCILLARY_GROUP_WEAPON_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_MEDICAL_ASSISTANCE:
                return ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_UNACCOMPANIED_MINOR:
                return ANCILLARY_GROUP_UNACCOMPANIED_MINOR_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_KIOSK:
                return ANCILLARY_GROUP_KIOSK_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_HAND_BAGGAGE:
                return ANCILLARY_GROUP_HAND_BAGGAGE_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_BOARDING:
                return ANCILLARY_GROUP_PREMIUM_BOARDING_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PRIORITY_CHECKIN:
                return ANCILLARY_GROUP_PRIORITY_CHECK_IN_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PREMIUM_CUSTOMER_CENTER:
                return ANCILLARY_GROUP_PREMIUM_CUSTOMER_CENTER_LIST;
            case ANCILLARY_PRODUCT_GROUP_CODE_PREF_BOARD:
                return ANCILLARY_GROUP_PREF_BOARDING_LIST;
            case '':
                return;
        }
    };
    /**
     * Returns true if code is present on fare information.
     * @param {string} code of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_isPresentOnFareInformation = function (code, flightId) {
        var returnValue = false;
        var group = this.INDRA_getSSRAvailableForGroup(code);
        var fareInformation = this.dataStorage.activeBooking["fare-information"];
        var fareInformationFlightId = fareInformation[flightId];
        if (fareInformationFlightId) {
            fareInformationFlightId.ancillaries.forEach(function (ancillaryCode) {
                if (group.includes(ancillaryCode)) {
                    returnValue = true;
                }
            });
        }
        return returnValue;
    };
    /**
     * Returns true if code is present on fare information.
     * @param {string} code of ancillary code
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_hasAncillary = function (code, flightId) {
        var returnValue = false;
        var fareInformation = this.dataStorage.activeBooking["fare-information"];
        if (fareInformation[flightId]) {
            fareInformation[flightId].ancillaries.forEach(function (ancillaryCode) {
                if (ancillaryCode === code) {
                    returnValue = true;
                }
            });
        }
        return returnValue;
    };
    /**
     * Returns true if code is present on purchased ancillaries.
     * @param {string} code of ancillary code
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_hasPurchasedAncillaryCodeOnSegment = function (code, flightCardId, segmentId) {
        var returnValue = false;
        if (!this.dataStorage.activeBooking.data.ancillaries.ancillaries
            || !this.dataStorage.activeBooking.data.ancillaries.ancillaries.length) {
            return returnValue;
        }
        this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
            ancillary.journey.forEach(function (journeyItem) {
                if (journeyItem.flightId === flightCardId && segmentId === journeyItem.segmentId) {
                    journeyItem.passengers.forEach(function (pax) {
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            if (code === ancillaryInfoItem.code) {
                                returnValue = true;
                            }
                        });
                    });
                }
            });
        });
        return returnValue;
    };
    /**
     * Returns object that tags all fare ancillaries to all passengers of the flight
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getPassengersAncillaryFareInformation = function (paramCode, flightId, excludeInfant) {
        var _this = this;
        if (excludeInfant === void 0) { excludeInfant = false; }
        var passengers = this.INDRA_getPaxInfo();
        var returnObject = [];
        var paxAncillaries = [];
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        if (flightIdfareInformation) {
            flightIdfareInformation.ancillaries.forEach(function (ancillaryCode) {
                if (group.includes(ancillaryCode)) {
                    paxAncillaries.push(ancillaryCode);
                }
            });
        }
        passengers.forEach(function (pax) {
            var _a;
            returnObject.push((_a = {},
                _a[pax.idPax] = excludeInfant && _this.INDRA_isPassengerInfant(pax, pax.idPax) ? [] : paxAncillaries.slice(),
                _a));
        });
        return returnObject.slice();
    };
    INDRABookingService.prototype.verifyInfantFareIncludesLuggage = function (infantTicketInfo) {
        return null;
    };
    /**
     * Returns object that tags all fare ancillaries to all passengers of the flight
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getPassengersTierBenefits = function (paramCode) {
        var passengers = this.INDRA_getPaxInfo();
        var returnObject = [];
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var tierFareinformation = this.dataStorage.activeBooking['tier-information'];
        passengers.forEach(function (pax) {
            var _a, _b;
            var tierKey = pax['tierLevelFF'];
            if (tierFareinformation && tierKey && tierFareinformation[tierKey]) {
                var paxAncillaries_1 = [];
                var ancillaryBenefits = tierFareinformation[tierKey];
                ancillaryBenefits.ancillaries.forEach(function (ancillaryCode) {
                    if (group.includes(ancillaryCode)) {
                        paxAncillaries_1.push(ancillaryCode);
                    }
                });
                returnObject.push((_a = {},
                    _a[pax.idPax] = paxAncillaries_1,
                    _a));
            }
            else {
                returnObject.push((_b = {},
                    _b[pax.idPax] = [],
                    _b));
            }
        });
        return returnObject.slice();
    };
    /** Checks if PNR is Award */
    INDRABookingService.prototype.INDRA_isAward = function (bookedTrip) {
        var passengers = bookedTrip.data.infoPax && bookedTrip.data.infoPax.listPax ? bookedTrip.data.infoPax.listPax : [];
        var isAward = false;
        if (passengers.length > 0) {
            passengers.forEach(function (passenger) {
                if (passenger && passenger.award) {
                    isAward = true;
                }
            });
        }
        return isAward;
    };
    /** Checks if PNR is Staff */
    INDRABookingService.prototype.INDRA_isStaff = function (bookedTrip) {
        var passengers = bookedTrip.data.infoPax && bookedTrip.data.infoPax.listPax ? bookedTrip.data.infoPax.listPax : [];
        var isStaff = false;
        if (passengers.length > 0) {
            passengers.forEach(function (passenger) {
                if (passenger && passenger.staff) {
                    isStaff = true;
                }
            });
        }
        return isStaff;
    };
    /**
     * Returns object that tags all purchased ancillaries per segment for all the passengers of the flight
     * @param {string} paramCode of ancillary
     * @param {string} flightId
     * @param {string} flightCardId same as assignedFlightId
     *
     */
    INDRABookingService.prototype.INDRA_getPassengersPurchasedAncillaryWithSegmentInfo = function (paramCode, flightId, flightCardId) {
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        if (!this.dataStorage.activeBooking.data.ancillaries.ancillaries
            || !this.dataStorage.activeBooking.data.ancillaries.ancillaries.length) {
            return returnObject.slice();
        }
        this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
            ancillary.journey.forEach(function (journeyItem) {
                if (journeyItem.flightId === flightId && segmentIDs.includes(journeyItem.segmentId)) {
                    journeyItem.passengers.forEach(function (pax) {
                        var unconfirmed = false;
                        var passengerId = Number(pax.paxId);
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            var _a, _b;
                            if (group.includes(ancillaryInfoItem.code)) {
                                if (UNCONFIRMED_CODES.includes(parseInt(ancillaryInfoItem.status))) {
                                    unconfirmed = true;
                                }
                                var paxIndex = returnObject.findIndex(function (object) { return object[passengerId]; });
                                if (paxIndex === -1) {
                                    // push pax, segment and ancillary code as it is not present yet on the return object
                                    var paxAncillaryList = [];
                                    var paxSegmentAncillary = [];
                                    paxSegmentAncillary.push({
                                        code: ancillaryInfoItem.code,
                                        // count: 1,
                                        count: ancillaryInfoItem && ancillaryInfoItem.quantity ? ancillaryInfoItem.quantity : 1,
                                        unconfirmed: unconfirmed,
                                        subCode: ancillaryInfoItem.subCode
                                    });
                                    paxAncillaryList.push({
                                        segmentId: journeyItem.segmentId,
                                        ancillaryList: paxSegmentAncillary
                                    });
                                    returnObject.push((_a = {},
                                        _a[passengerId] = paxAncillaryList,
                                        _a));
                                }
                                else {
                                    var paxAncillaryObject = returnObject[paxIndex];
                                    var paxAncillaryList = paxAncillaryObject[passengerId];
                                    var paxAncillaryIndex = paxAncillaryList.findIndex(function (paxAncillaryObject) { return paxAncillaryObject.segmentId === journeyItem.segmentId; });
                                    if (paxAncillaryIndex === -1) {
                                        // push segment and ancillary as it is not yet added for the pax
                                        var paxSegmentAncillary = [];
                                        paxSegmentAncillary.push({
                                            code: ancillaryInfoItem.code,
                                            count: ancillaryInfoItem && ancillaryInfoItem.quantity ? ancillaryInfoItem.quantity : 1,
                                            unconfirmed: unconfirmed,
                                            subCode: ancillaryInfoItem.subCode
                                        });
                                        paxAncillaryList.push({
                                            segmentId: journeyItem.segmentId,
                                            ancillaryList: paxSegmentAncillary
                                        });
                                    }
                                    else {
                                        var paxSegmentAncillaryList = paxAncillaryList[paxAncillaryIndex].ancillaryList;
                                        var paxSegmentAncillaryIndex = paxSegmentAncillaryList.findIndex(function (paxSegmentAncillaryObject) { return paxSegmentAncillaryObject.code === ancillaryInfoItem.code; });
                                        if (paxSegmentAncillaryIndex === -1) {
                                            // push ancillary code as it is not yet added for the segment
                                            paxSegmentAncillaryList.push({
                                                code: ancillaryInfoItem.code,
                                                count: ancillaryInfoItem && ancillaryInfoItem.quantity ? ancillaryInfoItem.quantity : 1,
                                                unconfirmed: unconfirmed,
                                                subCode: ancillaryInfoItem.subCode
                                            });
                                        }
                                        else {
                                            // increase count for the ancillary code if it's already added for the segment
                                            var addedCount = ancillaryInfoItem && ancillaryInfoItem.quantity ? ancillaryInfoItem.quantity : 0;
                                            var paxSegmentAncillaryCode = paxSegmentAncillaryList[paxSegmentAncillaryIndex];
                                            paxSegmentAncillaryCode.count = paxSegmentAncillaryCode.count + addedCount;
                                            paxSegmentAncillaryCode.unconfirmed = unconfirmed;
                                            paxSegmentAncillaryList[paxSegmentAncillaryIndex] = paxSegmentAncillaryCode;
                                            paxAncillaryList[paxAncillaryIndex] = {
                                                segmentId: journeyItem.segmentId,
                                                ancillaryList: paxSegmentAncillaryList
                                            };
                                        }
                                    }
                                    returnObject[paxIndex] = (_b = {}, _b[passengerId] = paxAncillaryList, _b);
                                }
                            }
                        });
                    });
                }
            });
        });
        return returnObject.slice();
    };
    /**
     * Returns object that tags all purchased ancillaries by the passengers of the flight
     * @param {string} paramCode of ancillary
     * @param {string} flightId
     * @param {string} flightCardId same as assignedFlightId
     */
    INDRABookingService.prototype.INDRA_getPassengersPurchasedAncillary = function (paramCode, flightId, flightCardId) {
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var passengers = this.INDRA_getPaxInfo();
        passengers.forEach(function (pax) {
            var _a;
            returnObject.push((_a = {},
                _a[pax.idPax] = [],
                _a));
        });
        if (!this.dataStorage.activeBooking.data.ancillaries.ancillaries
            || !this.dataStorage.activeBooking.data.ancillaries.ancillaries.length) {
            return returnObject.slice();
        }
        this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
            ancillary.journey.forEach(function (journeyItem) {
                if (journeyItem.flightId === flightId && segmentIDs.includes(journeyItem.segmentId)) {
                    journeyItem.passengers.forEach(function (pax) {
                        var passengerId = Number(pax.paxId);
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            if (group.includes(ancillaryInfoItem.code)) {
                                var index = returnObject.findIndex(function (object) { return object[passengerId]; });
                                var paxAncillary = returnObject[index];
                                if (!paxAncillary[passengerId].includes(ancillaryInfoItem.code)) {
                                    paxAncillary[passengerId].push(ancillaryInfoItem.code);
                                    returnObject[index] = paxAncillary;
                                }
                            }
                        });
                    });
                }
            });
        });
        return returnObject.slice();
    };
    INDRABookingService.prototype.INDRA_isAncillaryAvailable = function (purchasedCode, id) {
        var flight = this.INDRA_getBookedFlight(id);
        var hoursBeforeFlight = this.dateService.INDRA_getRemainingTimeInHours(flight.listSegment[0].departureDate);
        switch (purchasedCode) {
            case EXTRAS_ANCILLARY_BAG:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_BAG);
            case EXTRAS_ANCILLARY_EQUIPMENT:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EQUIPMENT);
            case EXTRAS_ANCILLARY_MEAL:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EXTRA_MEAL);
            case EXTRAS_ANCILLARY_ANIMAL:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EXTRA_ANIMAL);
            case EXTRAS_ANCILLARY_FAST_TRACK:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EXTRA_FAST_TRACK);
            case EXTRAS_ANCILLARY_LOUNGE:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EXTRA_LOUNGE);
            case EXTRAS_ANCILLARY_MUSICAL:
                return this.INDRA_featureIsAvailable(hoursBeforeFlight, PURCHASED_ANCILLARY_EXTRA_MUSICAL);
        }
    };
    INDRABookingService.prototype.INDRA_featureIsAvailable = function (hoursBeforeFlight, purchasedAncillary) {
        if (hoursBeforeFlight >= purchasedAncillary.hoursAvailableBeforeFlight) {
            return true;
        }
    };
    INDRABookingService.prototype.INDRA_getPaxInfo = function (includeInfant) {
        if (includeInfant === void 0) { includeInfant = true; }
        if (includeInfant) {
            return this.dataStorage.activeBooking.data.infoPax.listPax;
        }
        else {
            return this.dataStorage.activeBooking.data.infoPax.listPax.filter(function (pax) {
                return pax.typePax !== PAX_TYPE_INFANT_CODE;
            });
        }
    };
    /**
     *
     * @param {string} id of flightCard
     */
    INDRABookingService.prototype.INDRA_getBrand = function (id) {
        var flight = this.INDRA_getBookedFlight(id);
        if (!flight.fareFamily) {
            return '';
        }
        switch (flight.fareFamily.toUpperCase()) {
            case 'BDSC':
            case 'BDSI':
            case 'LDSC':
                return BRAND_DESCRIPTION_DISCOUNT;
            case 'BCLC':
            case 'BCLI':
            case 'LCLC':
                return BRAND_DESCRIPTION_CLASSIC;
            case 'BPUC':
            case 'BPUI':
            case 'BPLU':
            case 'LPLU':
                return BRAND_DESCRIPTION_PLUS;
            case 'BEXE':
            case 'BEXI':
            case 'LEXE':
                return BRAND_DESCRIPTION_EXECUTIVE;
            case 'BBSC':
            case 'BBSI':
            case 'LBSC':
                return BRAND_DESCRIPTION_BASIC;
            case 'BTTC':
            case 'BTTI':
            case 'BTOP':
                return BRAND_DESCRIPTION_TOP_EXECUTIVE;
        }
    };
    /**
     *
     * @param {string} fareFamily
     */
    INDRABookingService.prototype.INDRA_getBrandCode = function (fareFamily) {
        if (!fareFamily) {
            return '';
        }
        switch (fareFamily.toUpperCase()) {
            case 'BDSC':
            case 'BDSI':
            case 'LDSC':
                return BRAND_CODE_DISCOUNT;
            case 'BCLC':
            case 'BCLI':
            case 'LCLC':
                return BRAND_CODE_CLASSIC;
            case 'BPUC':
            case 'BPUI':
            case 'BPLU':
            case 'LPLU':
                return BRAND_CODE_PLUS;
            case 'BEXE':
            case 'BEXI':
            case 'LEXE':
                return BRAND_CODE_EXECUTIVE;
            case 'BBSC':
            case 'BBSI':
            case 'LBSC':
                return BRAND_CODE_BASIC;
            case 'BTTC':
            case 'BTTI':
            case 'BTOP':
                return BRAND_CODE_TOP_EXECUTIVE;
            default:
                return '';
        }
    };
    INDRABookingService.prototype.INDRA_getBrandCodeFromAmadeus = function (fareFamily) {
        if (fareFamily.includes('DIS')) {
            return BRAND_CODE_DISCOUNT;
        }
        else if (fareFamily.includes('BAS')) {
            return BRAND_CODE_BASIC;
        }
        else if (fareFamily.includes('CLA')) {
            return BRAND_CODE_CLASSIC;
        }
        else if (fareFamily.includes('PLU')) {
            return BRAND_CODE_PLUS;
        }
        else if (fareFamily.includes('EXE')) {
            return BRAND_CODE_EXECUTIVE;
        }
        else if (fareFamily.includes('TOP')) {
            return BRAND_CODE_TOP_EXECUTIVE;
        }
        else {
            return '';
        }
    };
    INDRABookingService.prototype.INDRA_getUpgradeWithMilesBrandCode = function (brandCode) {
        switch (brandCode) {
            case BRAND_CODE_DISCOUNT: return BRAND_CODE_BASIC;
            case BRAND_CODE_BASIC: return BRAND_CODE_CLASSIC;
            case BRAND_CODE_CLASSIC: return BRAND_CODE_PLUS;
            case BRAND_CODE_PLUS: return BRAND_CODE_EXECUTIVE;
            case BRAND_CODE_EXECUTIVE: return BRAND_CODE_TOP_EXECUTIVE;
        }
    };
    /**
     *
     * @param {string} id of flightCard
     * @return {string} location name of flight departure
     */
    INDRABookingService.prototype.INDRA_DepartureLocationOfFlight = function (id) {
        var flight = this.INDRA_getBookedFlight(id);
        var flightSegments = flight.listSegment;
        // note: should be the first 'flight' segment (not a BUS/TRAIN segment)
        if (flightSegments) {
            var flightOnlySegments = flightSegments.filter(function (segment) {
                return segment.equipment !== EQUIPMENT_CODE_TRAIN && segment.equipment !== EQUIPMENT_CODE_BUS;
            });
            if (flightOnlySegments && flightOnlySegments.length > 0) {
                return this.INDRA_getLocation(flightOnlySegments[0].departureAirport);
            }
        }
        return;
    };
    INDRABookingService.prototype.INDRA_getSegmentIDs = function (flightId) {
        var flight = this.INDRA_getBookedFlight(flightId);
        return flight.listSegment.map(function (segment) { return segment.idInfoSegment + ''; });
    };
    /**
     * Returns object that tags available add ons for the passengers of the flight
     * @param {string} type of ancillary
     * @param {string} flightId
     * @param {string} flightCardId same as assignedFlightId
     */
    INDRABookingService.prototype.INDRA_getAddOnAncillaries = function (type, flightId, flightCardId) {
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var passengers = this.INDRA_getPaxInfo();
        passengers.forEach(function (pax) {
            var _a;
            returnObject.push((_a = {},
                _a[pax.idPax] = [],
                _a));
        });
        if (this.dataStorage.activeBooking["ancillaries-data"] && this.dataStorage.activeBooking["ancillaries-data"].bundleList) {
            this.dataStorage.activeBooking["ancillaries-data"].bundleList.forEach(function (bundle) {
                bundle.ancillaryList.forEach(function (ancillary) {
                    if (ancillary.type === type) {
                        ancillary.catalog.forEach(function (catagalogItem) {
                            if (catagalogItem.flightId === Number(flightId) && segmentIDs.includes(catagalogItem.segmentId.toString())) {
                                catagalogItem.passengers.forEach(function (pax) {
                                    var _a;
                                    var passengerId = Number(pax.paxId);
                                    var index = returnObject.findIndex(function (object) { return object[passengerId]; });
                                    var paxCatalog = (_a = {}, _a[passengerId] = [], _a);
                                    var paxCatalogValue = paxCatalog[passengerId];
                                    var serviceCode = "";
                                    /* this if condition is initially applied for meal type only so all the available add on meals
                                    for all flight segments will be retrieved by this function */
                                    if (paxCatalogValue && type === EXTRAS_ANCILLARY_MEAL) {
                                        pax.codeList.forEach(function (code) {
                                            serviceCode = code.serviceCode;
                                            paxCatalogValue.push({
                                                code: code.code,
                                                currency: code.currency,
                                                maxQuantity: code.maxQuantity,
                                                price: code.price,
                                                itemId: ancillary.itemId,
                                                type: ancillary.type,
                                                flightId: catagalogItem.flightId,
                                                flightCardId: flightCardId,
                                                segmentId: catagalogItem.segmentId,
                                                flightBased: catagalogItem.flightBased,
                                                paxId: Number(pax.paxId),
                                                paxTatto: pax.paxTattoo.toString(),
                                                enabled: true,
                                                flightBasedAddOns: [],
                                                points: code.points ? code.points : 0,
                                                payWithMiles: false,
                                                aggregateSale: catagalogItem.aggregateSale,
                                                serviceCode: serviceCode
                                            });
                                        });
                                    }
                                    else {
                                        paxCatalog[passengerId] = pax.codeList.map(function (code) { return ({
                                            code: code.code,
                                            currency: code.currency,
                                            maxQuantity: code.maxQuantity,
                                            price: code.price,
                                            itemId: ancillary.itemId,
                                            type: ancillary.type,
                                            flightId: catagalogItem.flightId,
                                            flightCardId: flightCardId,
                                            segmentId: catagalogItem.segmentId,
                                            flightBased: catagalogItem.flightBased,
                                            paxId: Number(pax.paxId),
                                            paxTatto: pax.paxTattoo.toString(),
                                            enabled: true,
                                            flightBasedAddOns: [],
                                            points: code.points ? code.points : 0,
                                            payWithMiles: false,
                                            aggregateSale: catagalogItem.aggregateSale,
                                            serviceCode: code.serviceCode
                                        }); });
                                    }
                                    if (index >= 0) {
                                        paxCatalog[passengerId] = paxCatalog[passengerId].concat(returnObject[index][Object.keys(returnObject[index])[0]]);
                                        returnObject[index] = paxCatalog;
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }
        return returnObject.slice();
    };
    INDRABookingService.prototype.INDRA_hasNextFlight = function (flightCardId) {
        return (this.INDRA_getNextFlightCardId(flightCardId) > 0);
    };
    INDRABookingService.prototype.INDRA_hasPreviousFlight = function (flightCardId) {
        return (this.INDRA_getPreviousFlightCardId(flightCardId) >= 0);
    };
    INDRABookingService.prototype.INDRA_getNextFlightCardId = function (flightCardId) {
        var flightCardNum = Number(flightCardId);
        var isStopOverCard = false;
        var currentOutboundIndex = this.dataStorage.activeBooking.data.fare.listOutbound.findIndex(function (outbound) { return outbound.assignedFlightId === flightCardNum; });
        if (currentOutboundIndex >= 0) {
            isStopOverCard = this.dataStorage.activeBooking.data.fare.listOutbound[currentOutboundIndex].isStopOver;
        }
        var outboundIndex = this.dataStorage.activeBooking.data.fare.listOutbound.findIndex(function (outbound) { return outbound.assignedFlightId > flightCardNum; });
        if (isStopOverCard || outboundIndex === -1) {
            // returns next flight for stopover flights.
            if (outboundIndex !== -1) {
                return this.dataStorage.activeBooking.data.fare.listOutbound[outboundIndex].assignedFlightId;
                // checks outbound flights
            }
            else if (this.dataStorage.activeBooking.data.fare.listInbound) {
                var inboundIndex = this.dataStorage.activeBooking.data.fare.listInbound.findIndex(function (inbound) { return inbound.assignedFlightId > flightCardNum; });
                if (inboundIndex >= 0) {
                    // next flight found on inbound flights.
                    return this.dataStorage.activeBooking.data.fare.listInbound[inboundIndex].assignedFlightId;
                }
                /* else if (flightCardNum > 1) {
                    // search from the begining (circular navigation)
                    return this.INDRA_getNextFlightCardId('0');
                } */
            }
        }
        else {
            // next flight found on outbound flights.
            return this.dataStorage.activeBooking.data.fare.listOutbound[outboundIndex].assignedFlightId;
        }
        return -1;
    };
    INDRABookingService.prototype.INDRA_getPreviousFlightCardId = function (flightCardId) {
        var flightCardNum = Number(flightCardId);
        var isStopOverCard = false;
        var currentInboundIndex = null;
        if (this.dataStorage.activeBooking.data.fare.listInbound) {
            currentInboundIndex = this.dataStorage.activeBooking.data.fare.listInbound.findIndex(function (inbound) { return inbound.assignedFlightId === flightCardNum; });
            if (currentInboundIndex >= 0) {
                isStopOverCard = this.dataStorage.activeBooking.data.fare.listInbound[currentInboundIndex].isStopOver;
            }
        }
        if ((isStopOverCard || currentInboundIndex === null || currentInboundIndex < 0) && currentInboundIndex != 0) {
            // checks outbound flights
            if (this.dataStorage.activeBooking.data.fare.listOutbound) {
                var outboundIndex = this.dataStorage.activeBooking.data.fare.listOutbound.findIndex(function (outbound) { return flightCardNum === outbound.assignedFlightId; });
                if (outboundIndex > 0) {
                    // previous flight found on outbound flights.
                    return this.dataStorage.activeBooking.data.fare.listOutbound[--outboundIndex].assignedFlightId;
                }
                /* else {
                    // search from the end (circular navigation)
                    if (this.dataStorage.activeBooking.data.fare.listInbound) {
                        const lastItemIndex = this.dataStorage.activeBooking.data.fare.listInbound.length - 1;
                        return (this.dataStorage.activeBooking.data.fare.listInbound[lastItemIndex].assignedFlightId);
                    } else {
                        const lastItemIndex = this.dataStorage.activeBooking.data.fare.listOutbound.length - 1;
                        return (this.dataStorage.activeBooking.data.fare.listOutbound[lastItemIndex].assignedFlightId);
                    }
                }*/
            }
        }
        else if (currentInboundIndex === 0) {
            // previous flight is the last outbound flight
            var lastItemIndex = this.dataStorage.activeBooking.data.fare.listOutbound.length - 1;
            return (this.dataStorage.activeBooking.data.fare.listOutbound[lastItemIndex].assignedFlightId);
        }
        else {
            // previous flight found on inbound flights.
            return this.dataStorage.activeBooking.data.fare.listInbound[--currentInboundIndex].assignedFlightId;
        }
        return -1;
    };
    INDRABookingService.prototype.INDRA_getIBESeatDetails = function (flightId, flightCardId) {
        var _this = this;
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var passengers = this.INDRA_getPaxInfo();
        passengers.forEach(function (pax) {
            var _a;
            returnObject.push((_a = {},
                _a[pax.idPax] = [],
                _a));
        });
        if (this.dataStorage.activeBooking.data.ancillaries.seat) {
            this.dataStorage.activeBooking.data.ancillaries.seat.journey.forEach(function (journey) {
                if (journey.flightId === flightId && segmentIDs.includes(journey.segmentId)) {
                    journey.passengers.forEach(function (pax) {
                        var passengerId = Number(pax.paxId);
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            // if (ancillaryInfoItem.code === SSR_CODE_SEAT) {
                            if (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(ancillaryInfoItem.code)) {
                                var index = returnObject.findIndex(function (object) { return object[passengerId]; });
                                var paxAncillary = returnObject[index];
                                if (paxAncillary && !paxAncillary[passengerId].includes(ancillaryInfoItem.code)) {
                                    paxAncillary[passengerId].push({
                                        idPax: pax.paxId,
                                        seats: __assign({}, ancillaryInfoItem, { seatType: _this.INDRA_getIBESeatType(ancillaryInfoItem, flightId), priority: _this.INDRA_getSeatTypeToPriority(_this.INDRA_getSeatType(ancillaryInfoItem, flightId)) }),
                                        segmentId: journey.segmentId
                                    });
                                    returnObject[index] = paxAncillary;
                                }
                            }
                        });
                    });
                }
            });
        }
        // Store passenger with seat ancillaries
        var paxWithSeat = [];
        var paxIdWithSeat = [];
        returnObject.forEach(function (object) {
            Object.keys(object).forEach(function (key) {
                if (object[key].length > 0) {
                    paxWithSeat.push(object);
                    paxIdWithSeat.push(+key);
                }
            });
        });
        // Copy associated adult for infant
        returnObject.forEach(function (object) {
            Object.keys(object).forEach(function (key) {
                var seatPassenger = passengers.filter(function (passenger) {
                    return passenger.idPax === +key;
                })[0];
                if (seatPassenger.typePax === 'INF' && paxIdWithSeat.includes(seatPassenger.infToAdt)) {
                    returnObject.forEach(function (retObject) {
                        if (retObject[seatPassenger.infToAdt]) {
                            retObject[seatPassenger.infToAdt].forEach(function (element) {
                                var dataHolder = {
                                    idPax: seatPassenger.idPax,
                                    seats: element.seats,
                                    segmentId: element.segmentId
                                };
                                object[key].push(dataHolder);
                            });
                            object[key].forEach(function (infObj) {
                                infObj.idPax = seatPassenger.idPax;
                            });
                        }
                    });
                }
            });
        });
        return returnObject;
    };
    INDRABookingService.prototype.INDRA_getSeatDetails = function (flightId, flightCardId) {
        var _this = this;
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var passengers = this.INDRA_getPaxInfo();
        passengers.forEach(function (pax) {
            var _a;
            returnObject.push((_a = {},
                _a[pax.idPax] = [],
                _a));
        });
        if (this.dataStorage.activeBooking.data.ancillaries.seat) {
            this.dataStorage.activeBooking.data.ancillaries.seat.journey.forEach(function (journey) {
                if (journey.flightId === flightId && segmentIDs.includes(journey.segmentId)) {
                    journey.passengers.forEach(function (pax) {
                        var passengerId = Number(pax.paxId);
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            // if (ancillaryInfoItem.code === SSR_CODE_SEAT) {
                            if (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(ancillaryInfoItem.code)) {
                                var index = returnObject.findIndex(function (object) { return object[passengerId]; });
                                var paxAncillary = returnObject[index];
                                if (paxAncillary && !paxAncillary[passengerId].includes(ancillaryInfoItem.code)) {
                                    paxAncillary[passengerId].push({
                                        idPax: pax.paxId,
                                        seats: __assign({}, ancillaryInfoItem, { seatType: _this.INDRA_getSeatType(ancillaryInfoItem, flightId), priority: _this.INDRA_getSeatTypeToPriority(_this.INDRA_getSeatType(ancillaryInfoItem, flightId)) }),
                                        segmentId: journey.segmentId
                                    });
                                    returnObject[index] = paxAncillary;
                                }
                            }
                        });
                    });
                }
            });
        }
        // Store passenger with seat ancillaries
        var paxWithSeat = [];
        var paxIdWithSeat = [];
        returnObject.forEach(function (object) {
            Object.keys(object).forEach(function (key) {
                if (object[key].length > 0) {
                    paxWithSeat.push(object);
                    paxIdWithSeat.push(+key);
                }
            });
        });
        // Copy associated adult for infant
        returnObject.forEach(function (object) {
            Object.keys(object).forEach(function (key) {
                var seatPassenger = passengers.filter(function (passenger) {
                    return passenger.idPax === +key;
                })[0];
                if (seatPassenger.typePax === 'INF' && paxIdWithSeat.includes(seatPassenger.infToAdt)) {
                    returnObject.forEach(function (retObject) {
                        if (retObject[seatPassenger.infToAdt]) {
                            retObject[seatPassenger.infToAdt].forEach(function (element) {
                                var dataHolder = {
                                    idPax: seatPassenger.idPax,
                                    seats: element.seats,
                                    segmentId: element.segmentId
                                };
                                object[key].push(dataHolder);
                            });
                            object[key].forEach(function (infObj) {
                                infObj.idPax = seatPassenger.idPax;
                            });
                        }
                    });
                }
            });
        });
        return returnObject;
    };
    INDRABookingService.prototype.INDRA_getLoyaltyMiles = function (flightId) {
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        var miles = flightIdfareInformation.miles ? flightIdfareInformation.miles : 0;
        return miles;
    };
    INDRABookingService.prototype.INDRA_getLoyaltyMilesByFlightCardId = function (flightId, flightCardId) {
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        var miles = 0;
        if (flightIdfareInformation.milesByFlightCard) {
            if (_.has(flightIdfareInformation.milesByFlightCard, flightCardId)) {
                miles = _.get(flightIdfareInformation.milesByFlightCard, flightCardId).miles;
            }
        }
        if (!miles || miles === 0)
            miles = flightIdfareInformation.miles ? flightIdfareInformation.miles : 0;
        return miles;
    };
    INDRABookingService.prototype.INDRA_getLoyaltyMilesPerTier = function (flightId, tier) {
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        var miles = flightIdfareInformation.miles ? flightIdfareInformation.miles : 0;
        var actualMiles = flightIdfareInformation.actualMiles ? flightIdfareInformation.actualMiles : 0;
        var tierInformation = this.dataStorage.activeBooking['tier-information'];
        if (!tierInformation || !tier) {
            return miles;
        }
        var tierLevelInformation = tierInformation[tier];
        if (!tierLevelInformation || !tierLevelInformation['milesPercentage']) {
            return miles;
        }
        var percentage = parseFloat(tierLevelInformation['milesPercentage']);
        var plus = (actualMiles * percentage) / 100;
        return Math.round(plus + miles);
    };
    INDRABookingService.prototype.INDRA_getLoyaltyMilesPerTierByFlightCardId = function (flightId, tier, flightCardId) {
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        var miles = 0;
        var actualMiles = 0;
        var segmentMilesTotal = 0;
        if (flightIdfareInformation.milesByFlightCardBySegment && flightIdfareInformation.milesByFlightCardBySegment[flightId]) {
            var flightCard_1 = flightIdfareInformation.milesByFlightCardBySegment[flightCardId];
            var tierPercentage_1;
            var tierInformation = this.dataStorage.activeBooking['tier-information'];
            if (tierInformation && tierInformation[tier] && tierInformation[tier]['milesPercentage']) {
                tierPercentage_1 = tierInformation[tier]['milesPercentage'];
            }
            Object.keys(flightCard_1).forEach(function (flight) {
                if (!_.isEmpty(flightCard_1[flight])) {
                    segmentMilesTotal += flightCard_1[flight].actualMiles * (flightCard_1[flight].milesPercentage / 100);
                    // add actual miles * user tier level percentage
                    if (tierPercentage_1)
                        segmentMilesTotal += flightCard_1[flight].actualMiles * (tierPercentage_1 / 100);
                }
            });
            return Math.round(segmentMilesTotal);
        }
        else {
            miles = flightIdfareInformation.miles ? flightIdfareInformation.miles : 0;
            actualMiles = flightIdfareInformation.actualMiles ? flightIdfareInformation.actualMiles : 0;
            var tierInformation = this.dataStorage.activeBooking['tier-information'];
            if (!tierInformation || !tier) {
                return miles;
            }
            var tierLevelInformation = tierInformation[tier];
            if (!tierLevelInformation || !tierLevelInformation['milesPercentage']) {
                return miles;
            }
            var percentage = parseFloat(tierLevelInformation['milesPercentage']);
            var plus = (actualMiles * percentage) / 100;
            return Math.round(plus + miles);
        }
    };
    INDRABookingService.prototype.createChangeBookingSteps = function (selectedFlights, selectedDate) {
        this._steps = this.INDRA_createStepsArray(selectedFlights, selectedDate);
        this.steps.next(this._steps);
    };
    INDRABookingService.prototype.INDRA_createStepsArray = function (selectedFlightsArray, selectedDate) {
        var STEPS_ARRAY = [];
        for (var index = 0; selectedFlightsArray.length > index; index++) {
            STEPS_ARRAY.push(new INDRABookingStep(this.INDRA_getLocation(selectedFlightsArray[index].details.listSegment[0].departureAirport), this.INDRA_getLocation(selectedFlightsArray[index].details.listSegment[0].arrivalAirport), this.dateService.INDRA_convertDate(selectedDate[index].date.date), selectedFlightsArray[index].bound));
        }
        return STEPS_ARRAY;
    };
    // private static createBookingSteps(formValue: any): Array<BookingStep> {
    // 	let steps = [];
    // 	switch (formValue.routeType) {
    // 		case 'round trip':
    // 			steps = [
    // 				new BookingStep(formValue.from, formValue.to),
    // 				new BookingStep(formValue.to, formValue.from)
    // 			];
    // 			break;
    // 		case 'one way':
    // 			steps = [new BookingStep(formValue.from, formValue.to)];
    // 			break;
    // 		default:
    // 			steps = DATES_BOOKING_STEPS_STATE;
    // 			break;
    // 	}
    // 	return steps;
    // }
    /**
     * Sets bookingSteps[@index] to @value
     * @param value
     * @param index
     */
    INDRABookingService.prototype.setStepDate = function (value, index) {
        this._steps[index].date = value;
        this._steps[index].date_selected = value !== null;
        this.steps.next(this._steps);
        this.goToNextStep();
    };
    /** Called when a step is complete */
    INDRABookingService.prototype.goToNextStep = function () {
        if (!this.isLastStep(this._current_step)) {
            this._current_step++;
            this.current_step.next(this._current_step);
        }
    };
    /**
     * Returns whether or not the given index is the last step of the booking process
     * @param index index of the step to check
     * @returns whether index is last step
     */
    INDRABookingService.prototype.isLastStep = function (index) {
        if (!index) {
            index = this._current_step;
        }
        return index === this._steps.length - 1;
    };
    /**
     * Returns corresponding flight of an ID if it exists
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_getSegment = function (flightCardId, segmentId) {
        var flight;
        var index = this.dataStorage.activeBooking.data.fare.listOutbound.findIndex(function (outbound) { return outbound.assignedFlightId.toString() === flightCardId; });
        var returnValue = null;
        if (index === -1) {
            // if id is not present on outbound flight, returns inbound
            if (this.dataStorage.activeBooking.data.fare.listInbound) {
                var inboundIndex = this.dataStorage.activeBooking.data.fare.listInbound.findIndex(function (inbound) { return inbound.assignedFlightId.toString() === flightCardId; });
                flight = this.dataStorage.activeBooking.data.fare.listInbound[inboundIndex];
            }
        }
        else {
            // returns outbound
            flight = this.dataStorage.activeBooking.data.fare.listOutbound[index];
        }
        var segmentIndex = flight.listSegment.findIndex(function (segment) { return segment.idInfoSegment.toString() === segmentId; });
        returnValue = flight.listSegment[segmentIndex];
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_setExtraChanged = function (key, value) {
        // let extra = {};
        // extra[key] = value;
        // const newBookedTrip = Object.assign(new BookedTrip(null, null, null), this.bookingTrip, extra);
        // this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    /**
     * Sorts ancillaries associated to the passenger by flight's segment id
     * @param {any} ancillaryList list of ancillary associated to the passenger
     * @param {any} flight flight details to provide the segmentId
     */
    INDRABookingService.prototype.INDRA_sortBySegment = function (ancillaryList, flight) {
        var sortedList = [];
        if (ancillaryList.length > 0) {
            var segmentList_1 = [];
            flight.listSegment.forEach(function (segment) {
                segmentList_1.push(segment.idInfoSegment.toString());
            });
            segmentList_1.forEach(function (segmentId) {
                ancillaryList.forEach(function (item) {
                    if (segmentId === item.segmentId) {
                        sortedList.push(item);
                    }
                });
            });
        }
        return sortedList;
    };
    INDRABookingService.prototype.INDRA_isPassengerInfant = function (pax, idPax) {
        if (pax && pax.idPax && pax.typePax) {
            if (pax.idPax == idPax && pax.typePax == PAX_TYPE_INFANT_CODE) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns object that will be identified as available add on for the passengers of the flight segment
     * @param {string} type of ancillary
     * @param {number} flightId
     * @param {string} flightCardId same as assignedFlightId
     * @param {number} segmentId
     * @param {string} ancillaryCode
     * @param {string} price
     * @param {number} paxId
     */
    INDRABookingService.prototype.INDRA_getAddOnAncillariesForPassengerSegment = function (type, flightCardId, flightId, segmentId, ancillaryCode, paxId) {
        var returnObject = {
            code: undefined,
            currency: undefined,
            maxQuantity: undefined,
            price: undefined,
            itemId: undefined,
            type: undefined,
            flightId: undefined,
            flightCardId: undefined,
            segmentId: undefined,
            flightBased: undefined,
            paxId: undefined,
            paxTatto: undefined,
            enabled: undefined,
            ssrTatto: undefined,
            flightBasedAddOns: [],
            serviceCode: undefined
        };
        if (this.dataStorage.activeBooking["ancillaries-data"] && this.dataStorage.activeBooking["ancillaries-data"].bundleList) {
            this.dataStorage.activeBooking["ancillaries-data"].bundleList.forEach(function (bundle) {
                bundle.ancillaryList.forEach(function (ancillary) {
                    if (ancillary.type === type) {
                        ancillary.catalog.forEach(function (catagalogItem) {
                            if (catagalogItem.flightId === flightId && segmentId === catagalogItem.segmentId) {
                                catagalogItem.passengers.forEach(function (pax) {
                                    if (pax.paxId.toString() === paxId.toString()) {
                                        var codeItem = pax.codeList.filter(function (codeItem) { return codeItem.code === ancillaryCode; })[0];
                                        if (codeItem) {
                                            returnObject = {
                                                code: codeItem.code,
                                                currency: codeItem.currency,
                                                maxQuantity: codeItem.maxQuantity,
                                                price: codeItem.price,
                                                itemId: ancillary.itemId,
                                                type: ancillary.type,
                                                flightId: catagalogItem.flightId,
                                                flightCardId: flightCardId,
                                                segmentId: catagalogItem.segmentId,
                                                flightBased: catagalogItem.flightBased,
                                                paxId: Number(pax.paxId),
                                                paxTatto: pax.paxTattoo.toString(),
                                                enabled: true,
                                                ssrTatto: undefined,
                                                flightBasedAddOns: [],
                                                serviceCode: codeItem.serviceCode
                                            };
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }
        return returnObject;
    };
    INDRABookingService.prototype.INDRA_checkIfCodeShare = function (listSegment) {
        //NOTE: codeShare = check if operationCarrier is not 'TP'
        // then hide Extra baggage,Sports equipment, Pets, Musical instruments
        var hiddenCodes = [];
        hiddenCodes.push.apply(hiddenCodes, TP_EXPRESS_LOGO);
        hiddenCodes.push(AIR_LINE_CODE_TAP);
        var codeShare = listSegment.find(function (segment) { return (!hiddenCodes.includes(segment.operationCarrier)); });
        if (codeShare) {
            return true;
        }
        return false;
    };
    INDRABookingService.prototype.INDRA_checkIfAllPassengersAreChildren = function (passengers) {
        var isChildren = false;
        if (passengers && passengers.length > 0) {
            for (var i = 0; i < passengers.length; i++) {
                var pax = passengers[i];
                if (pax.typePax == PAX_TYPE_CHILD_CODE) {
                    isChildren = true;
                }
                else {
                    isChildren = false;
                    break;
                }
            }
            return isChildren;
        }
        else {
            return false;
        }
    };
    /**
     * Returns object that tags all fare ancillaries to all passengers of the flight
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getFareInformation = function (paramCode, flightId) {
        var fareInfoAncillaries = [];
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        if (flightIdfareInformation) {
            flightIdfareInformation.ancillaries.forEach(function (ancillaryCode) {
                if (group.includes(ancillaryCode)) {
                    fareInfoAncillaries.push(ancillaryCode);
                }
            });
        }
        return fareInfoAncillaries.slice();
    };
    /**
     * Returns object that tags all purchased ancillaries to all passengers of the flight
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getPurchasedFeatures = function (paramCode, flightId, flightCardId, paxId) {
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var purchasedFeatureCountArray = [];
        if (!this.dataStorage.activeBooking.data.ancillaries.ancillaries
            || !this.dataStorage.activeBooking.data.ancillaries.ancillaries.length) {
            return purchasedFeatureCountArray;
        }
        this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
            ancillary.journey.forEach(function (journeyItem) {
                if (journeyItem.flightId === flightId && segmentIDs.includes(journeyItem.segmentId)) {
                    journeyItem.passengers.forEach(function (pax) {
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            if (group.includes(ancillaryInfoItem.code) && pax.paxId === paxId) {
                                var purchaseFeatureIndex = purchasedFeatureCountArray.findIndex(function (checkedBaggageItem) { return checkedBaggageItem.code === ancillaryInfoItem.code; });
                                if (purchaseFeatureIndex === -1) {
                                    purchasedFeatureCountArray.push({
                                        code: ancillaryInfoItem.code,
                                        count: 1,
                                        subCode: ancillaryInfoItem.subCode
                                    });
                                }
                                else {
                                    purchasedFeatureCountArray[purchaseFeatureIndex].count = purchasedFeatureCountArray[purchaseFeatureIndex].count + 1;
                                }
                            }
                        });
                    });
                }
            });
        });
        return purchasedFeatureCountArray;
    };
    INDRABookingService.prototype.INDRA_linkRouteData = function (url, query) {
        if (url === void 0) { url = null; }
        if (query === void 0) { query = null; }
        var data = {
            queryParams: query,
            link: url
        };
        this.subjectLinkRoute.next(data);
    };
    INDRABookingService.prototype.getCurrentPNR = function () {
        var booking = this.dataStorage.INDRA_getActiveBookedTrip();
        if (booking) {
            return booking.data.pnr;
        }
        return '';
    };
    INDRABookingService.prototype.INDRA_getPurchasedSeatDetails = function (flightId, flightCardId) {
        var _this = this;
        var returnObject = [];
        var segmentIDs = this.INDRA_getSegmentIDs(flightCardId);
        if (this.dataStorage.activeBooking.data.ancillaries.seat) {
            this.dataStorage.activeBooking.data.ancillaries.seat.journey.forEach(function (journey) {
                var segmentId = Number(journey.segmentId);
                if (journey.flightId === flightId.toString() && segmentIDs.includes(journey.segmentId)) {
                    journey.passengers.forEach(function (pax) {
                        var passengerId = Number(pax.paxId);
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            // if (ancillaryInfoItem.code === SSR_CODE_SEAT) {
                            if (ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(ancillaryInfoItem.code) && ancillaryInfoItem.seatCode) {
                                returnObject.push({
                                    code: EXTRAS_ANCILLARY_SEAT_SSR,
                                    currency: undefined,
                                    maxQuantity: 0,
                                    price: ancillaryInfoItem.price,
                                    itemId: _this.INDRA_getAddOnAncillariesItemId(EXTRAS_ANCILLARY_SEAT, flightId, segmentId, passengerId),
                                    type: EXTRAS_ANCILLARY_SEAT,
                                    flightId: flightId,
                                    flightCardId: flightCardId,
                                    segmentId: segmentId,
                                    flightBased: undefined,
                                    paxId: passengerId,
                                    paxTatto: pax.paxId,
                                    enabled: true,
                                    ssrTatto: ancillaryInfoItem.ssrTatto,
                                    value: ancillaryInfoItem.seatCode.replace(/^0+/, ''),
                                    flightBasedAddOns: [],
                                    serviceCode: undefined
                                });
                            }
                        });
                    });
                }
            });
        }
        return returnObject;
    };
    INDRABookingService.prototype.INDRA_getAddOnAncillariesItemId = function (type, flightId, segmentId, paxId) {
        var itemId = 0;
        if (this.dataStorage.activeBooking["ancillaries-data"] && this.dataStorage.activeBooking["ancillaries-data"].bundleList) {
            this.dataStorage.activeBooking["ancillaries-data"].bundleList.forEach(function (bundle) {
                bundle.ancillaryList.forEach(function (ancillary) {
                    if (ancillary.type === type) {
                        ancillary.catalog.forEach(function (catagalogItem) {
                            if (catagalogItem.flightId === flightId && segmentId === catagalogItem.segmentId) {
                                catagalogItem.passengers.forEach(function (pax) {
                                    if (pax.paxId.toString() === paxId.toString()) {
                                        itemId = ancillary.itemId;
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }
        return itemId;
    };
    INDRABookingService.prototype.INDRA_getStorageLastName = function () {
        return this.dataStorage.INDRA_getLastName();
    };
    INDRABookingService.prototype.INDRA_hasPurchasedAncillary = function () {
        if (this.dataStorage && this.dataStorage.activeBooking.data.ancillaries && this.dataStorage.activeBooking.data.ancillaries.ancillaries.length > 0) {
            return true;
        }
        else {
            return false;
        }
    };
    INDRABookingService.prototype.INDRA_ifFlightHasPurchasedAncillary = function (id, passengers) {
        if (id === void 0) { id = []; }
        if (passengers === void 0) { passengers = []; }
        var ancillaryList = this.dataStorage.INDRA_getActiveBookedTrip() ? this.dataStorage.activeBooking.data.ancillaries.ancillaries : [];
        var hasPurchasedAncillary = false;
        var excludedAncillaries = [EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL];
        if (this.dataStorage && ancillaryList.length > 0) {
            ancillaryList.forEach(function (list) {
                if (list.journey && list.journey.length > 0) {
                    list.journey.forEach(function (journ) {
                        if (journ.flightId) {
                            var hasFound = id.find(function (element) {
                                return element.toString() == journ.flightId.toString();
                            });
                            if (hasFound) {
                                if (journ.passengers && journ.passengers.length > 0 && passengers.length > 0) {
                                    journ.passengers.forEach(function (pax) {
                                        var purchasedItems;
                                        var hasFound = passengers.find(function (element) {
                                            purchasedItems = pax.ancillaryInfo.filter(function (ancillary) {
                                                return ancillary.price > 0;
                                            });
                                            return purchasedItems.length > 0 && element.toString() == pax.paxId.toString();
                                        });
                                        if (hasFound) {
                                            hasPurchasedAncillary = true;
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            });
        }
        return hasPurchasedAncillary;
    };
    INDRABookingService.prototype.INDRA_ifFlightHasPurchasedSeat = function (id, passengers) {
        if (id === void 0) { id = []; }
        if (passengers === void 0) { passengers = []; }
        var ancillaryList = this.dataStorage.INDRA_getActiveBookedTrip() && this.dataStorage.INDRA_getActiveBookedTrip().data.ancillaries.seat ?
            this.dataStorage.activeBooking.data.ancillaries.seat.journey : [];
        var hasPurchasedAncillary = false;
        var excludedAncillaries = [EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL];
        if (this.dataStorage && ancillaryList.length > 0) {
            ancillaryList.forEach(function (journ) {
                if (journ.flightId) {
                    var hasFound = id.find(function (element) {
                        return element.toString() == journ.flightId.toString();
                    });
                    if (hasFound) {
                        if (journ.passengers && journ.passengers.length > 0 && passengers.length > 0) {
                            journ.passengers.forEach(function (pax) {
                                var purchasedItems;
                                var hasFound = passengers.find(function (element) {
                                    purchasedItems = pax.ancillaryInfo.filter(function (ancillary) {
                                        return ancillary.price > 0;
                                    });
                                    return purchasedItems.length > 0 && element.toString() == pax.paxId.toString();
                                });
                                if (hasFound) {
                                    hasPurchasedAncillary = true;
                                }
                            });
                        }
                    }
                }
            });
        }
        return hasPurchasedAncillary;
    };
    INDRABookingService.prototype.INDRA_ifFlightHasAssignedSeat = function (passengers) {
        if (passengers === void 0) { passengers = []; }
        var ancillaryList = this.dataStorage.INDRA_getActiveBookedTrip() && this.dataStorage.INDRA_getActiveBookedTrip().data.ancillaries.seat ?
            this.dataStorage.activeBooking.data.ancillaries.seat.journey : [];
        var hasPurchasedAncillary = false;
        var excludedAncillaries = [EXTRAS_ANCILLARY_EQUIPMENT, EXTRAS_ANCILLARY_MUSICAL, EXTRAS_ANCILLARY_ANIMAL];
        if (this.dataStorage && ancillaryList.length > 0) {
            ancillaryList.forEach(function (journ) {
                if (journ.flightId) {
                    if (journ.passengers && journ.passengers.length > 0 && passengers.length > 0) {
                        journ.passengers.forEach(function (pax) {
                            var purchasedItems;
                            var hasFound = passengers.find(function (element) {
                                purchasedItems = pax.ancillaryInfo.filter(function (ancillary) {
                                    return ANCILLARY_GROUP_SEAT_RESERVATION_LIST.includes(ancillary.code);
                                });
                                return purchasedItems.length > 0 && element.toString() == pax.paxId.toString();
                            });
                            if (hasFound) {
                                hasPurchasedAncillary = true;
                            }
                        });
                    }
                }
            });
        }
        return hasPurchasedAncillary;
    };
    INDRABookingService.prototype.INDRA_getBoundObject = function (flight, activeFare) {
        var inboundFlights = activeFare.listInbound.filter(function (inbound) {
            return inbound.idFlight === flight.idFlight;
        });
        var outboundFlights = activeFare.listOutbound.filter(function (outbound) {
            return outbound.idFlight === flight.idFlight;
        });
        return inboundFlights.length > 0 ? inboundFlights : outboundFlights;
    };
    /**
     * Returns label for tier level
     */
    INDRABookingService.prototype.INDRA_getTierKeyLabel = function (passengerInfo) {
        switch (passengerInfo.tierLevelFF) {
            case TAP_MILES_AND_GO_MILES:
            case TAP_MILES_AND_GO_MILS:
                return TAP_MILES_AND_GO_MILES_LABEL;
            case TAP_MILES_AND_GO_SILVER:
                return TAP_MILES_AND_GO_SILVER_LABEL;
            case TAP_MILES_AND_GO_GOLD:
                return TAP_MILES_AND_GO_GOLD_LABEL;
            case TAP_MILES_AND_GO_NAVIGATOR:
                return TAP_MILES_AND_GO_NAVIGATOR_LABEL;
            default:
                return '';
        }
    };
    /**
     * 	Retrieves the original flight information (unmassaged) retrieved from the PNR Search service..
     */
    INDRABookingService.prototype.INDRA_getOriginalFlightDetails = function (idFlight) {
        var returnValue;
        var index = this.dataStorage.originalPNRDetailsResponse.data.fare.listOutbound.findIndex(function (outbound) { return outbound.idFlight === idFlight; });
        if (index === -1) {
            // if id is not present on outbound flight, returns inbound
            returnValue = this.dataStorage.originalPNRDetailsResponse.data.fare.inbound;
        }
        else {
            // returns outbound
            returnValue = this.dataStorage.originalPNRDetailsResponse.data.fare.listOutbound[index];
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getFlightRoute = function (flight) {
        return flight;
    };
    INDRABookingService.prototype.INDRA_getFlightRouteAggregate = function (flight, aggregateSale) {
        // returns the original bound flight on flight route for flights with stopover..
        if (flight.isStopOver) {
            return this.INDRA_getOriginalFlightDetails(flight.idFlight);
        }
        else {
            if (aggregateSale && aggregateSale != undefined && aggregateSale !== 'undefined' && aggregateSale != null) {
                // returns the flights for the sale merged
                return this.INDRA_getFlightsForAggregateSale(flight, aggregateSale);
            }
            return flight;
        }
    };
    INDRABookingService.prototype.INDRA_getFlightsForAggregateSale = function (flight, aggregateSale) {
        var firstFlight = _.cloneDeep(flight);
        aggregateSale = aggregateSale.replace(flight.idFlight + '', '');
        var flightsToMerge = aggregateSale.split(',');
        for (var i = 0; i < flightsToMerge.length; i++) {
            if ((!flightsToMerge[i] || flightsToMerge[i].length === 0)) {
                continue;
            }
            var currentFlight = this.INDRA_getBookedFlightBySegment(flightsToMerge[i]);
            firstFlight.lastSegment = currentFlight.lastSegment;
            firstFlight.listSegment = firstFlight.listSegment.concat(currentFlight.listSegment);
        }
        return firstFlight;
    };
    INDRABookingService.prototype.INDRA_isPassengerPresentOnTierLevel = function (code, passengers) {
        if (passengers === void 0) { passengers = []; }
        var returnValue = false;
        var paxTierLevelCount = 0;
        var group = this.INDRA_getSSRAvailableForGroup(code);
        var tierInformation = this.dataStorage.activeBooking['tier-information'];
        if (passengers.length > 0) {
            passengers.forEach(function (pax) {
                if (pax.tierLevelFF) {
                    var tierKey = pax['tierLevelFF'];
                    if (tierInformation && tierInformation[tierKey]) {
                        tierInformation[tierKey].ancillaries.forEach(function (ancillaryCode) {
                            if (group.includes(ancillaryCode)) {
                                paxTierLevelCount++;
                            }
                        });
                    }
                }
            });
        }
        if (passengers.length === paxTierLevelCount) {
            returnValue = true;
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getSeatImages = function (seatType, equipment, duration) {
        var images = [];
        var generalPlanFolder = SEATMAP_SEAT_TYPE_FOLDER_GENERAL;
        var seatTypeFolder = this.INDRA_getTypeFolderName(seatType, equipment, duration);
        var seatTypeFolderDescription = this.INDRA_getTypeFolderNameDescription(seatType, equipment, duration);
        var equipmentFolder = this.INDRA_getEquipmentFolderName(equipment, duration);
        if (equipmentFolder && seatTypeFolder) {
            var equipmentPath = SEATMAP_SEAT_IMAGE_PATH_ANCILLARIES_SEAT + "/" + equipmentFolder;
            switch (equipment) {
                case SEATMAP_AIRBUS_A319_100_CODE:
                case SEATMAP_AIRBUS_A320_200_CODE:
                case SEATMAP_AIRBUS_A321_200_CODE:
                case SEATMAP_AIRBUS_A320_NEO_CODE:
                    images = this.INDRA_getSeatImagesForAirbus319To321(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_AIRBUS_A330_200_RETROFIT_CODE:
                    images = this.INDRA_getSeatImagesForAirbus332(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_AIRBUS_A340_300_CODE:
                    images = this.INDRA_getSeatImagesForAirbus343(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_AIRBUS_ATR_72_600_CODE:
                    images = this.INDRA_getSeatImagesForATR72600(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_EMBRAER_190_CODE:
                    images = this.INDRA_getSeatImagesForEmbraer190(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_EMBRAER_195_CODE:
                    images = this.INDRA_getSeatImagesForEmbraer195(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                case SEATMAP_AIRBUS_A321_NEO_CODE: {
                    if (FlightEquipmentEnum.isLongRange(equipment, duration)) {
                        images = this.INDRA_getSeatImagesForAirbus321NEO(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    }
                    else {
                        images = this.INDRA_getSeatImagesForAirbus319To321(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    }
                    return images;
                }
                case SEATMAP_AIRBUS_A330_NEO_CODE:
                    images = this.INDRA_getSeatImagesForAirbus330NEO(seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription);
                    return images;
                default:
                    images = [];
                    return images;
            }
        }
        else {
            return images;
        }
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForAirbus319To321 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                images = [
                    // {
                    // 	path_url: `${equipmentPath}/${generalPlanFolder}/seat-1.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                ];
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                images = [
                    // {
                    // 	path_url: `${equipmentPath}/${generalPlanFolder}/seat-1.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    // {
                    // 	path_url: `${equipmentPath}/${seatTypeFolder}/seat-2.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    // {
                    // 	path_url: `${equipmentPath}/${seatTypeFolder}/seat-4.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    // {
                    // 	path_url: `${equipmentPath}/${seatTypeFolder}/seat-6.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-7.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-8.jpg",
                        description: seatTypeFolderDescription
                    },
                    // {
                    // 	path_url: `${equipmentPath}/${seatTypeFolder}/seat-9.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    // {
                    // 	path_url: `${equipmentPath}/${seatTypeFolder}/seat-10.jpg`,
                    // 	description: seatTypeFolderDescription
                    // },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-11.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-12.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-6.jpg",
                        description: seatTypeFolderDescription
                    },
                ];
                break;
            default:
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForAirbus332 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-6.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-7.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-8.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-10.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-11.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-12.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-13.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-14.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            default:
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForAirbus343 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                images = [];
                break;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            default:
                images = [];
                break;
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForATR72600 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD: {
                images = [
                    {
                        path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
            }
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForAirbus321NEO = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            default:
                images = [];
                break;
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForAirbus330NEO = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-6.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-6.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-7.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                images = [
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-1.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-2.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-3.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-4.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-5.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-6.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-7.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-8.jpg",
                        description: seatTypeFolderDescription
                    },
                    {
                        path_url: equipmentPath + "/" + seatTypeFolder + "/seat-9.jpg",
                        description: seatTypeFolderDescription
                    }
                ];
                break;
            default:
                images = [];
                break;
        }
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForEmbraer190 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        images = [
            {
                path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                description: seatTypeFolderDescription
            }
        ];
        return images;
    };
    INDRABookingService.prototype.INDRA_getSeatImagesForEmbraer195 = function (seatType, equipmentPath, generalPlanFolder, seatTypeFolder, seatTypeFolderDescription) {
        var images = [];
        images = [
            {
                path_url: equipmentPath + "/" + generalPlanFolder + "/seat-1.jpg",
                description: seatTypeFolderDescription
            },
            {
                path_url: equipmentPath + "/" + SEATMAP_SEAT_IMAGE_PATH_INTERIORES_195 + "/seat-1.jpg",
                description: seatTypeFolderDescription
            },
            {
                path_url: equipmentPath + "/" + SEATMAP_SEAT_IMAGE_PATH_INTERIORES_195 + "/seat-2.jpg",
                description: seatTypeFolderDescription
            },
            {
                path_url: equipmentPath + "/" + SEATMAP_SEAT_IMAGE_PATH_INTERIORES_195 + "/seat-3.jpg",
                description: seatTypeFolderDescription
            }
        ];
        return images;
    };
    INDRABookingService.prototype.INDRA_getEquipmentFolderName = function (equipment, duration) {
        switch (equipment) {
            case SEATMAP_AIRBUS_A319_100_CODE:
            case SEATMAP_AIRBUS_A320_200_CODE:
            case SEATMAP_AIRBUS_A321_200_CODE:
            case SEATMAP_AIRBUS_A320_NEO_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_A319_A320_A321;
            case SEATMAP_AIRBUS_A330_200_RETROFIT_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_A332;
            case SEATMAP_AIRBUS_A340_300_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_A340;
            case SEATMAP_AIRBUS_ATR_72_600_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_ATR;
            case SEATMAP_EMBRAER_190_CODE:
            case SEATMAP_EMBRAER_195_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_EMBRAER;
            case SEATMAP_AIRBUS_A321_NEO_CODE: {
                if (FlightEquipmentEnum.isLongRange(equipment, duration)) {
                    return SEATMAP_EQUIPMENT_FOLDER_A321_LR;
                }
                else {
                    return SEATMAP_EQUIPMENT_FOLDER_A319_A320_A321;
                }
            }
            case SEATMAP_AIRBUS_A330_NEO_CODE:
                return SEATMAP_EQUIPMENT_FOLDER_A330_NEO;
            default:
                return undefined;
        }
    };
    INDRABookingService.prototype.INDRA_getTypeFolderName = function (seatType, equipment, duration) {
        var equipmentWithExecutive = [
            SEATMAP_AIRBUS_A319_100_CODE,
            SEATMAP_AIRBUS_A320_200_CODE,
            SEATMAP_AIRBUS_A321_200_CODE,
            SEATMAP_AIRBUS_A330_200_RETROFIT_CODE,
            SEATMAP_AIRBUS_A320_NEO_CODE
        ];
        if (!FlightEquipmentEnum.isLongRange(equipment, duration)) {
            equipmentWithExecutive = equipmentWithExecutive.concat(SEATMAP_AIRBUS_A321_NEO_CODE);
        }
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                return SEATMAP_SEAT_TYPE_FOLDER_STANDARD;
            case SEATMAP_SEAT_TYPE_PREFERED:
                return SEATMAP_SEAT_TYPE_FOLDER_PREFERED;
            case SEATMAP_SEAT_TYPE_BUSINESS:
                return equipmentWithExecutive.includes(equipment) ? SEATMAP_SEAT_TYPE_FOLDER_EXECUTIVE : SEATMAP_SEAT_TYPE_FOLDER_BUSINESS;
            default:
                return undefined;
        }
    };
    INDRABookingService.prototype.INDRA_getTypeFolderNameDescription = function (seatType, equipment, duration) {
        var equipmentWithExecutive = [
            SEATMAP_AIRBUS_A319_100_CODE,
            SEATMAP_AIRBUS_A320_200_CODE,
            SEATMAP_AIRBUS_A321_200_CODE,
            SEATMAP_AIRBUS_A330_200_RETROFIT_CODE,
            SEATMAP_AIRBUS_A320_NEO_CODE
        ];
        if (!FlightEquipmentEnum.isLongRange(equipment, duration)) {
            equipmentWithExecutive = equipmentWithExecutive.concat(SEATMAP_AIRBUS_A321_NEO_CODE);
        }
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_STANDARD:
                return this.INDRA_getTextTranslation('bookingDetails.alt.seatTypeEconomy');
            case SEATMAP_SEAT_TYPE_PREFERED:
                return this.INDRA_getTextTranslation('bookingDetails.alt.seatTypeEconomyXtra');
            case SEATMAP_SEAT_TYPE_BUSINESS:
                return equipmentWithExecutive.includes(equipment) ? this.INDRA_getTextTranslation('bookingDetails.alt.seatTypeExecutive') : this.INDRA_getTextTranslation('bookingDetails.alt.seatTypeBusiness');
            default:
                return undefined;
        }
    };
    /** Gets the last segment with equipment unequal to TRN */
    INDRABookingService.prototype.INDRA_getLastSegmentFlightIgnoringTrain = function (listSegment) {
        var returnVal;
        listSegment.forEach(function (segment) {
            if (segment.equipment !== EQUIPMENT_CODE_TRAIN) {
                returnVal = segment;
            }
        });
        return returnVal;
    };
    /** Gets the first segment with equipment unequal to TRN */
    INDRABookingService.prototype.INDRA_getFirstSegmentFlightIgnoringTrain = function (listSegment) {
        return listSegment.filter(function (segment) {
            return segment.equipment !== EQUIPMENT_CODE_TRAIN;
        })[0];
    };
    INDRABookingService.prototype.INDRA_getFlightBoundType = function (idFlight) {
        var returnValue = undefined;
        var index = this.dataStorage.originalPNRDetailsResponse.data.fare.listOutbound.findIndex(function (outbound) { return outbound.idFlight === idFlight; });
        index === -1 ? returnValue === 'inbound' : 'outbound';
        return returnValue;
    };
    /**
     * Checks if PNR's office data is in TAP's GDS Office pattern
     * @param officeData bookedTrip.data.office
     */
    INDRABookingService.prototype.INDRA_isTAPGDSOffice = function (officeData) {
        if (officeData === void 0) { officeData = ''; }
        return officeData.substring(3, 6) === TAP_GDS_OFFICE_PATTERN;
    };
    /**
     * Checks if PNR's office data is in EXPEDIA's GDS Office pattern
     * @param officeData bookedTrip.data.office
     */
    INDRABookingService.prototype.INDRA_isEXPEDIAGDSOffice = function (officeData) {
        if (officeData === void 0) { officeData = ''; }
        return officeData.substring(3, 5) === EXPEDIA_GDS_OFFICE_PATTERN;
    };
    /**
     * Checks if PNR's office data is in EDREAMS's GDS Office pattern
     * @param officeData bookedTrip.data.office
     */
    INDRABookingService.prototype.INDRA_isEDREAMSGDSOffice = function (officeData) {
        if (officeData === void 0) { officeData = ''; }
        return officeData.substring(3, 5) === EDREAMS_GDS_OFFICE_PATTERN;
    };
    /**
     * Checks if PNR's office data is in OPODO's GDS Office pattern
     * @param officeData bookedTrip.data.office
     */
    INDRABookingService.prototype.INDRA_isOPODOGDSOffice = function (officeData) {
        if (officeData === void 0) { officeData = ''; }
        return officeData.substring(3, 5) === OPODO_GDS_OFFICE_PATTERN;
    };
    INDRABookingService.prototype.INDRA_hasTapOperatedSegment = function (listSegment) {
        var tapCarriers = [];
        tapCarriers.push.apply(tapCarriers, TP_EXPRESS_LOGO);
        tapCarriers.push(AIR_LINE_CODE_TAP);
        var codeShare = listSegment.find(function (segment) { return (tapCarriers.includes(segment.operationCarrier)); });
        if (codeShare) {
            return true;
        }
        return false;
    };
    /**
     * Returns object that tags all purchased ancillaries of paxId on the flight segment
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getPaxPurchasedFeaturesOnFlightSegment = function (flightId, segmentId, paxId) {
        var purchasedFeatureCountArray = [];
        if (this.dataStorage.activeBooking.data.ancillaries && this.dataStorage.activeBooking.data.ancillaries.ancillaries) {
            this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
                ancillary.journey.forEach(function (journeyItem) {
                    if (journeyItem.flightId === flightId && segmentId === journeyItem.segmentId) {
                        journeyItem.passengers.forEach(function (pax) {
                            pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                                if (pax.paxId === paxId) {
                                    var purchaseFeatureIndex = purchasedFeatureCountArray.findIndex(function (checkedBaggageItem) { return checkedBaggageItem.code === ancillaryInfoItem.code; });
                                    if (purchaseFeatureIndex === -1) {
                                        purchasedFeatureCountArray.push({
                                            code: ancillaryInfoItem.code,
                                            count: 1,
                                            subCode: ancillaryInfoItem.subCode
                                        });
                                    }
                                    else {
                                        purchasedFeatureCountArray[purchaseFeatureIndex].count = purchasedFeatureCountArray[purchaseFeatureIndex].count + 1;
                                    }
                                }
                            });
                        });
                    }
                });
            });
        }
        return purchasedFeatureCountArray;
    };
    /**
     * Returns corresponding flight of an ID if it exists.
     * listSegment of the flight would only contain segments that are codeshare/interline..
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly = function (id) {
        var returnValue;
        var flight = this.INDRA_getBookedFlight(id);
        if (flight) {
            var listSegment = flight.listSegment, rest = __rest(flight, ["listSegment"]);
            var filteredListSegment = listSegment.filter(function (segment) { return CODE_SHARE_INTERLINE_FLIGHT_OPERATION_CARRIER.includes(segment.operationCarrier); });
            returnValue = __assign({}, rest, { listSegment: filteredListSegment });
        }
        return returnValue;
    };
    /**
     * Returns all bound flights that possesses the idFlight parameter.
     * More than one flight will be returned by this function for flights with stopover scenario.
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_getBoundFlightsByFlightId = function (idFlight) {
        var returnValue = [];
        returnValue = this.dataStorage.activeBooking.data.fare.listOutbound.filter(function (outbound) { return outbound.idFlight === idFlight; });
        if (returnValue.length === 0) {
            // if flight is not on outbound flight, returns inbound
            if (this.dataStorage.activeBooking.data.fare.listInbound) {
                returnValue = this.dataStorage.activeBooking.data.fare.listInbound.filter(function (inbound) { return inbound.idFlight === idFlight; });
            }
        }
        return returnValue;
    };
    /**
     * Checks if the flightCardId is the first flight card created for the idFlight.
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_checkFlightCardIfFirstCardOfTheFlight = function (flightCardId, idFlight) {
        var flag = false;
        var boundFlightsOfFlightId = this.INDRA_getBoundFlightsByFlightId(idFlight);
        if (boundFlightsOfFlightId[0] && boundFlightsOfFlightId[0].assignedFlightId === flightCardId) {
            flag = true;
        }
        return flag;
    };
    /**.
     * checks listSegment of the flight if it has codeshare/interline..
     * @param {string} id of flight to return
     */
    INDRABookingService.prototype.INDRA_checkFlightHasInterlineFlight = function (id) {
        var flag = false;
        var flight = this.INDRA_getBookedFlightWithSegmentsOperatedByInterlineFlightsOnly(id);
        if (flight && flight.listSegment && flight.listSegment.length > 0) {
            flag = true;
        }
        return flag;
    };
    /**
     * Checks if PNR has issued tickets
     **/
    INDRABookingService.prototype.INDRA_checkIfPNRIssuedTickets = function () {
        var hasIssuedTicket = false;
        var infoTicket = this.dataStorage.activeBooking.data.infoTicket;
        if (infoTicket && infoTicket.listTicket && infoTicket.listTicket.length > 0) {
            hasIssuedTicket = true;
        }
        return hasIssuedTicket;
    };
    INDRABookingService.prototype.INDRA_isUnavailableFlight = function (flightId, totalSummary) {
        var listPax = this.dataStorage.INDRA_getActiveBookedTrip().data.infoPax.listPax;
        var unavailableFlight = false;
        var flightCtr = 0;
        if (totalSummary && totalSummary['flagged-flights']) {
            var flaggedFlights_1 = totalSummary['flagged-flights'];
            listPax.forEach(function (paxInfo) {
                var idPax = paxInfo.idPax.toString();
                if (flaggedFlights_1[idPax] && flaggedFlights_1[idPax].length > 0) {
                    var hasFlight = flaggedFlights_1[idPax].includes(flightId.toString());
                    if (hasFlight) {
                        flightCtr++;
                    }
                }
            });
        }
        if (flightCtr > 0) {
            unavailableFlight = true;
        }
        return unavailableFlight;
    };
    INDRABookingService.prototype.INDRA_getFirstSegmentByFlightCard = function (flightCardId) {
        var segmentId = -1;
        this.dataStorage.activeBooking.data.fare.listOutbound.forEach(function (outbound) {
            if (outbound.assignedFlightId == flightCardId && segmentId === -1) {
                var listSegment = outbound.listSegment.filter(function (segment) { return segment.equipment !== EQUIPMENT_CODE_BUS && segment.equipment !== EQUIPMENT_CODE_TRAIN; });
                segmentId = listSegment[0].idInfoSegment;
            }
        });
        if (segmentId === -1) {
            this.dataStorage.activeBooking.data.fare.listInbound.forEach(function (inbound) {
                if (inbound.assignedFlightId == flightCardId && segmentId === -1) {
                    var listSegment = inbound.listSegment.filter(function (segment) { return segment.equipment !== EQUIPMENT_CODE_BUS && segment.equipment !== EQUIPMENT_CODE_TRAIN; });
                    segmentId = listSegment[0].idInfoSegment;
                }
            });
        }
        return segmentId;
    };
    /**
     * Returns object that tags all purchased ancillaries of passenger on the flight's first segment
     * @param {string} paramCode of ancillary group
     * @param {string} flightId
     */
    INDRABookingService.prototype.INDRA_getPurchasedFeaturesOfFlightCardFirstSegment = function (paramCode, flightId, flightCardId, paxId) {
        var firstSegmentId = this.INDRA_getFirstSegmentByFlightCard(flightCardId);
        var group = this.INDRA_getSSRAvailableForGroup(paramCode);
        var purchasedFeatureCountArray = [];
        if (!this.dataStorage.activeBooking.data.ancillaries.ancillaries
            || !this.dataStorage.activeBooking.data.ancillaries.ancillaries.length) {
            return purchasedFeatureCountArray;
        }
        this.dataStorage.activeBooking.data.ancillaries.ancillaries.forEach(function (ancillary) {
            ancillary.journey.forEach(function (journeyItem) {
                if (journeyItem.flightId === flightId && firstSegmentId.toString() === journeyItem.segmentId) {
                    journeyItem.passengers.forEach(function (pax) {
                        pax.ancillaryInfo.forEach(function (ancillaryInfoItem) {
                            if (group.includes(ancillaryInfoItem.code) && pax.paxId === paxId) {
                                var purchaseFeatureIndex = purchasedFeatureCountArray.findIndex(function (checkedBaggageItem) { return checkedBaggageItem.code === ancillaryInfoItem.code; });
                                if (purchaseFeatureIndex === -1) {
                                    purchasedFeatureCountArray.push({
                                        code: ancillaryInfoItem.code,
                                        count: ancillaryInfoItem.quantity,
                                        subCode: ancillaryInfoItem.subCode
                                    });
                                    if (paramCode === ANCILLARY_PRODUCT_GROUP_CODE_HOLD_BAGGAGE && ancillaryInfoItem['status']) {
                                        purchasedFeatureCountArray[purchasedFeatureCountArray.length - 1]['status'] = ancillaryInfoItem.status;
                                    }
                                }
                                else {
                                    purchasedFeatureCountArray[purchaseFeatureIndex].count = purchasedFeatureCountArray[purchaseFeatureIndex].count + ancillaryInfoItem.quantity;
                                }
                            }
                        });
                    });
                }
            });
        });
        return purchasedFeatureCountArray;
    };
    INDRABookingService.prototype.INDRA_getBusinessFeatures = function (equipment) {
        switch (equipment) {
            case AIRPLANE_EQUIPMENT_CODE_32Q:
                return BUSINESS_A321LR.features;
            case AIRPLANE_EQUIPMENT_CODE_32N:
                return BUSINESS_A320NEO.features;
            case AIRPLANE_EQUIPMENT_CODE_339:
                return BUSINESS_A330NEO.features;
            case AIRPLANE_EQUIPMENT_CODE_332:
                return BUSINESS_A330.features;
            default:
                return BUSINESS_DEFAULT.features;
        }
    };
    INDRABookingService.prototype.INDRA_getSeatTypeToPriority = function (seatType) {
        switch (seatType) {
            case SEATMAP_SEAT_TYPE_BUSINESS:
                return 1;
                break;
            case SEATMAP_SEAT_TYPE_PREFERED:
                return 2;
            case SEATMAP_SEAT_TYPE_STANDARD:
                return 3;
        }
    };
    INDRABookingService.prototype.INDRA_getSeatType = function (ancInfo, flightIdentifier) {
        var returnValue = SEATMAP_SEAT_TYPE_STANDARD;
        var flight = this.INDRA_getBookedFlight(flightIdentifier);
        var brandCode = this.INDRA_getBrandCode(flight.fareFamily);
        if (brandCode && (brandCode === BRAND_CODE_EXECUTIVE || brandCode === BRAND_CODE_TOP_EXECUTIVE)) {
            return SEATMAP_SEAT_TYPE_BUSINESS;
        }
        else {
            if (ancInfo && ancInfo.freeText && ancInfo.freeText === 'O') {
                return SEATMAP_SEAT_TYPE_PREFERED;
            }
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getIBESeatType = function (ancInfo, flightIdentifier) {
        var returnValue = SEATMAP_SEAT_TYPE_STANDARD;
        var flight = this.INDRA_getBookedFlight(flightIdentifier);
        var brandCode = this.INDRA_getBrandCodeFromAmadeus(flight.fareFamily);
        if (brandCode && (brandCode === BRAND_CODE_EXECUTIVE || brandCode === BRAND_CODE_TOP_EXECUTIVE)) {
            return SEATMAP_SEAT_TYPE_BUSINESS;
        }
        else {
            if (ancInfo && ancInfo.freeText && ancInfo.freeText === 'O') {
                return SEATMAP_SEAT_TYPE_PREFERED;
            }
        }
        return returnValue;
    };
    INDRABookingService.prototype.INDRA_getIncludedFeature = function (includedAncillaryGroupCode, flightId, genericAncillaryLabel) {
        var group = this.INDRA_getSSRAvailableForGroup(includedAncillaryGroupCode);
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        var includedAncillaries = [];
        if (flightIdfareInformation) {
            flightIdfareInformation.ancillaries.forEach(function (ancillaryCode) {
                if (group.includes(ancillaryCode)) {
                    includedAncillaries.push(ancillaryCode);
                }
            });
        }
        var feature = {
            id: includedAncillaryGroupCode,
            code: includedAncillaryGroupCode,
            label: genericAncillaryLabel,
            labelTranslationKey: 'ancillaries.group.' + group[0],
            icon: null,
            extra: false,
            type: 'added',
            includedAncillaries: includedAncillaries
        };
        return feature;
    };
    /** checks if specific ancillary catalog is present or is available for the current booking and flight **/
    INDRABookingService.prototype.INDRA_isAncillaryCatalogAvailableForBooking = function (ancillaryCatalogGroupCode, flight) {
        var bookedTrip = this.dataStorage.INDRA_getActiveBookedTrip();
        var catalogs = null;
        if (bookedTrip["ancillaries-data"] && bookedTrip["ancillaries-data"].bundleList) {
            catalogs = bookedTrip["ancillaries-data"].bundleList.find(function (bundleItem) { return bundleItem['ancillaryList'][0].type === ancillaryCatalogGroupCode; });
        }
        var ancillaryCatalog = catalogs && catalogs.ancillaryList && catalogs.ancillaryList.length > 0 ?
            catalogs.ancillaryList[0].catalog : null;
        var isAvailable = false;
        if (ancillaryCatalog && flight && flight.listSegment && flight.listSegment.length > 0) {
            flight.listSegment.forEach(function (segment) {
                if (ancillaryCatalog.find(function (item) { return (item.flightId.toString() == flight.idFlight.toString()
                    && item.segmentId.toString() == segment.idInfoSegment.toString()); })) {
                    isAvailable = true;
                }
            });
        }
        return isAvailable;
    };
    /** gets specific ancillary catalog aggregateSale for the current booking and flight **/
    INDRABookingService.prototype.INDRA_getAggregateSaleForTypeAndFlight = function (ancillaryCatalogGroupCode, flight) {
        var aggregateSale = null;
        var bookedTrip = this.dataStorage.INDRA_getActiveBookedTrip();
        if (bookedTrip.data.fare.tripType === TRIP_TYPE_MULTICITY_CODE) {
            var catalogs = null;
            if (bookedTrip['ancillaries-data'] && bookedTrip['ancillaries-data'].bundleList) {
                catalogs = bookedTrip['ancillaries-data'].bundleList.find(function (bundleItem) { return bundleItem['ancillaryList'][0].type === ancillaryCatalogGroupCode; });
            }
            var ancillaryCatalog_1 = catalogs && catalogs.ancillaryList && catalogs.ancillaryList.length > 0 ?
                catalogs.ancillaryList[0].catalog : null;
            if (ancillaryCatalog_1 && flight && flight.listSegment && flight.listSegment.length > 0) {
                flight.listSegment.forEach(function (segment) {
                    var ancillaryCatalogItem = ancillaryCatalog_1.find(function (item) { return (item.flightId.toString() == flight.idFlight.toString()
                        && item.segmentId.toString() == segment.idInfoSegment.toString() && item.aggregateSale); });
                    if (ancillaryCatalogItem && ancillaryCatalogItem != null && ancillaryCatalogItem.aggregateSale && ancillaryCatalogItem.aggregateSale != null) {
                        aggregateSale = ancillaryCatalogItem.aggregateSale;
                    }
                });
            }
        }
        return aggregateSale;
    };
    INDRABookingService.prototype.INDRA_getFlightSegmentsCountryList = function (segmentList) {
        var _this = this;
        var countries = [];
        if (segmentList && segmentList.length > 0) {
            segmentList.forEach(function (segment) {
                var departureCountryCode = _this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.departureAirport].countryCode;
                var arrivalCountryCode = _this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.arrivalAirport].countryCode;
                if (countries.filter(function (country) { return country !== departureCountryCode; }))
                    countries.push(departureCountryCode);
                if (countries.filter(function (country) { return country !== arrivalCountryCode; }))
                    countries.push(arrivalCountryCode);
            });
        }
        return countries;
    };
    INDRABookingService.prototype.INDRA_getOriginCountry = function (booked_trip) {
        var _this = this;
        var originCountry = [];
        if (booked_trip && booked_trip.data.fare.listOutbound && booked_trip.data.fare.listOutbound.length > 0) {
            var tripType = booked_trip.data.fare.tripType;
            if (tripType === TRIP_TYPE_MULTICITY_CODE) {
                booked_trip.data.fare.listOutbound.forEach(function (outbound) {
                    if (outbound.firstSegment) {
                        originCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[outbound.firstSegment.departureAirport].countryCode);
                    }
                });
            }
            else {
                if (booked_trip.data.fare.listOutbound[0] && booked_trip.data.fare.listOutbound[0].listSegment &&
                    booked_trip.data.fare.listOutbound[0].listSegment[0]) {
                    var departureAirport = booked_trip.data.fare.listOutbound[0].listSegment[0].departureAirport;
                    originCountry.push(this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[departureAirport].countryCode);
                }
            }
        }
        return originCountry;
    };
    INDRABookingService.prototype.INDRA_getArrivalCountry = function (booked_trip, withStop) {
        var _this = this;
        if (withStop === void 0) { withStop = false; }
        var arrivalCountry = [];
        if (booked_trip && booked_trip.data.fare.listOutbound && booked_trip.data.fare.listOutbound.length > 0) {
            var tripType = booked_trip.data.fare.tripType;
            if (tripType === TRIP_TYPE_MULTICITY_CODE) {
                booked_trip.data.fare.listOutbound.forEach(function (outbound) {
                    if (outbound.listSegment) {
                        if (withStop) {
                            outbound.listSegment.forEach(function (segment) {
                                arrivalCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.arrivalAirport].countryCode);
                            });
                        }
                        else {
                            arrivalCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[outbound.listSegment[outbound.listSegment.length - 1].arrivalAirport].countryCode);
                        }
                    }
                });
            }
            else {
                if (withStop) {
                    if (booked_trip.data.fare.listOutbound && booked_trip.data.fare.listOutbound.length > 0) {
                        booked_trip.data.fare.listOutbound.forEach(function (outbound) {
                            if (outbound.listSegment) {
                                outbound.listSegment.forEach(function (segment) {
                                    if (segment.arrivalAirport) {
                                        arrivalCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.arrivalAirport].countryCode);
                                    }
                                });
                            }
                        });
                    }
                    if (booked_trip.data.fare.listInbound && booked_trip.data.fare.listInbound.length > 0) {
                        booked_trip.data.fare.listInbound.forEach(function (inbound) {
                            if (inbound.listSegment) {
                                inbound.listSegment.forEach(function (segment) {
                                    if (segment.arrivalAirport) {
                                        arrivalCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.arrivalAirport].countryCode);
                                    }
                                });
                            }
                        });
                    }
                }
                else {
                    if (booked_trip.data.fare.listOutbound && booked_trip.data.fare.listOutbound.length > 0) {
                        var outboundLength = booked_trip.data.fare.listOutbound.length;
                        if (booked_trip.data.fare.listOutbound[outboundLength - 1] && booked_trip.data.fare.listOutbound[outboundLength - 1].listSegment && booked_trip.data.fare.listOutbound[outboundLength - 1].listSegment.length > 0) {
                            booked_trip.data.fare.listOutbound[outboundLength - 1].listSegment.forEach(function (segment) {
                                if (segment.arrivalAirport) {
                                    arrivalCountry.push(_this.dataStorage.INDRA_getActiveBookedTrip().translate.locations[segment.arrivalAirport].countryCode);
                                }
                            });
                        }
                    }
                }
            }
        }
        return arrivalCountry;
    };
    INDRABookingService.prototype.INDRA_getBookingTripCountries = function (booked_trip) {
        var tripCountries = this.INDRA_getOriginCountry(booked_trip);
        return tripCountries.concat(this.INDRA_getArrivalCountry(booked_trip));
    };
    INDRABookingService.prototype.INDRA_isUSAFlight = function (booked_trip) {
        var _this = this;
        var hasUSAFlight = false;
        if (booked_trip && booked_trip.data.fare.listOutbound && booked_trip.data.fare.listOutbound.length > 0) {
            booked_trip.data.fare.listOutbound.forEach(function (outbound) {
                var countryList = _this.INDRA_getFlightSegmentsCountryList(outbound.listSegment);
                if (countryList.includes(COUNTRY_CODE_USA)) {
                    hasUSAFlight = true;
                }
            });
        }
        if (booked_trip && booked_trip.data.fare.listInbound && booked_trip.data.fare.listInbound.length > 0) {
            booked_trip.data.fare.listInbound.forEach(function (inbound) {
                var countryList = _this.INDRA_getFlightSegmentsCountryList(inbound.listSegment);
                if (countryList.includes(COUNTRY_CODE_USA)) {
                    hasUSAFlight = true;
                }
            });
        }
        return hasUSAFlight;
    };
    /** Checks if PNR has passengers travelling for work */
    INDRABookingService.prototype.INDRA_isTravellingForWork = function (bookedTrip) {
        var passengers = bookedTrip.data.infoPax && bookedTrip.data.infoPax.listPax ? bookedTrip.data.infoPax.listPax : [];
        var isTravellingForWork = false;
        if (passengers.length > 0) {
            passengers.forEach(function (passenger) {
                if (passenger && passenger.workTrip) {
                    isTravellingForWork = true;
                }
            });
        }
        return isTravellingForWork;
    };
    INDRABookingService.prototype.INDRA_isFlightEcononomyExtra = function (flightId) {
        var fareInformation = this.dataStorage.activeBooking['fare-information'];
        var flightIdfareInformation = fareInformation[flightId];
        return (flightIdfareInformation && flightIdfareInformation['economy-extra-elegible']);
    };
    INDRABookingService.prototype.INDRA_getCurrentFlight = function () {
        if (this.dataStorage.activeBooking.data.fare) {
            var activeOutbounds = this.dataStorage.activeBooking.data.fare.listOutbound.filter(function (bound) { return !bound.flightFlown; });
            if (!_.isEmpty(activeOutbounds)) {
                return activeOutbounds[0];
            }
            else {
                if (!_.isEmpty(this.dataStorage.activeBooking.data.fare.listInbound)) {
                    var activeInbounds = this.dataStorage.activeBooking.data.fare.listInbound.filter(function (bound) { return !bound.flightFlown; });
                    if (!_.isEmpty(activeInbounds)) {
                        return activeInbounds[0];
                    }
                }
            }
        }
        return null;
    };
    /**
     * Checks if all dates have been selected for the ongoing booking
     * @returns {boolean}
     */
    INDRABookingService.prototype.allDatesSelected = function () {
        for (var i = 0; i < this._steps.length; i++) {
            if (!this._steps[i].date_selected) {
                return false;
            }
        }
        return true;
    };
    /**
     * Checks if all flights have been selected for the ongoing booking
     * @returns {boolean}
     */
    INDRABookingService.prototype.allFlightsSelected = function () {
        for (var i = 0; i < this._steps.length; i++) {
            if (!this._steps[i].flight_selected) {
                return false;
            }
        }
        return true;
    };
    /*
      *
       */
    INDRABookingService.prototype.updateFooterData = function (stage, payload) {
        if (stage === 'flights') {
            this.pendingFlight.next({ flt: payload.flight, time: payload.time });
        }
        if (stage === 'multicity') {
            this.multiFlights.next({ flts: payload.flights });
        }
    };
    /**
     * Clear selected dates
     */
    INDRABookingService.prototype.INDRA_clearDates = function () {
        var auxArray = [];
        this._steps.forEach(function (step) {
            auxArray.push(Object.assign(new BookingStep(null, null), step, {
                cost: null,
                date: null,
                date_selected: false
            }));
        });
        this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
    };
    /**
     * When the last step is reached and the route must be changed,
     * call this function
     */
    INDRABookingService.prototype.goToNextRoute = function () {
        var current_route = this.router.url;
        var split = current_route.split('?');
        var route_split = split && split[0] ? split[0] : current_route;
        switch (route_split) {
            case '/booking/dates':
                this.router.navigateByUrl('/booking/flights');
                return;
            case '/booking/dates/deeplink':
                this.router.navigateByUrl('/booking/flights');
                return;
            case '/booking/flights':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights-multicity':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights-multicity/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/main/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            default:
                console.error(current_route);
                return;
        }
    };
    INDRABookingService.ngInjectableDef = i0.defineInjectable({ factory: function INDRABookingService_Factory() { return new INDRABookingService(i0.inject(i1.INDRABFMDataStorageService), i0.inject(i2.INDRADateService), i0.inject(i3.INDRATotalSummaryService), i0.inject(i4.INDRARetrievePnrService), i0.inject(i5.INDRAIbeAdminService), i0.inject(i6.Store), i0.inject(i7.Router)); }, token: INDRABookingService, providedIn: "root" });
    return INDRABookingService;
}());
export { INDRABookingService };
